class {
    onCreate(input) {
        this.state = {
            map: new Map([
                ["right-text-hex", input.rightTextHex || "#000000"]
            ])
        };
    }
}


<div>
    <div class="solar_term Beginning-of-Spring">
        <h2>立春</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#FFF799"
                data-cmyk-text="CMYK(0,0,50,0)"
                style="background-color: rgb(255, 247, 153);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄白游
                </h3>
                <div class="color__hex">#FFF799</div>
                <div class="color__rgb">RGB(255, 247, 153)</div>
                <div class="color__cmyk">CMYK(0,0,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#FFEE6F"
                data-cmyk-text="CMYK(0,5,65,0)"
                style="background-color: rgb(255, 238, 111);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    松花
                </h3>
                <div class="color__hex">#FFEE6F</div>
                <div class="color__rgb">RGB(255, 238, 111)</div>
                <div class="color__cmyk">CMYK(0,5,65,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ECD452"
                data-cmyk-text="CMYK(10,15,75,5)"
                style="background-color: rgb(236, 212, 82);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    缃叶
                </h3>
                <div class="color__hex">#ECD452</div>
                <div class="color__rgb">RGB(236, 212, 82)</div>
                <div class="color__cmyk">CMYK(10,15,75,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B6A014"
                data-cmyk-text="CMYK(35,35,100,0)"
                style="background-color: rgb(182, 160, 20);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苍黄
                </h3>
                <div class="color__hex">#B6A014</div>
                <div class="color__rgb">RGB(182, 160, 20)</div>
                <div class="color__cmyk">CMYK(35,35,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D5EBE1"
                data-cmyk-text="CMYK(20,0,15,0)"
                style="background-color: rgb(213, 235, 225);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    天缥
                </h3>
                <div class="color__hex">#D5EBE1</div>
                <div class="color__rgb">RGB(213, 235, 225)</div>
                <div class="color__cmyk">CMYK(20,0,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B1D5C8"
                data-cmyk-text="CMYK(35,5,25,0)"
                style="background-color: rgb(177, 213, 200);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    沧浪
                </h3>
                <div class="color__hex">#B1D5C8</div>
                <div class="color__rgb">RGB(177, 213, 200)</div>
                <div class="color__cmyk">CMYK(35,5,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#99BCAC"
                data-cmyk-text="CMYK(45,15,35,0)"
                style="background-color: rgb(153, 188, 172);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苍筤
                </h3>
                <div class="color__hex">#99BCAC</div>
                <div class="color__rgb">RGB(153, 188, 172)</div>
                <div class="color__cmyk">CMYK(45,15,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#80A492"
                data-cmyk-text="CMYK(55,25,45,0)"
                style="background-color: rgb(128, 164, 146);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    缥碧
                </h3>
                <div class="color__hex">#80A492</div>
                <div class="color__rgb">RGB(128, 164, 146)</div>
                <div class="color__cmyk">CMYK(55,25,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8B7042"
                data-cmyk-text="CMYK(50,55,80,10)"
                style="background-color: rgb(139, 112, 66);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    流黄
                </h3>
                <div class="color__hex">#8B7042</div>
                <div class="color__rgb">RGB(139, 112, 66)</div>
                <div class="color__cmyk">CMYK(50,55,80,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#775039"
                data-cmyk-text="CMYK(55,70,80,20)"
                style="background-color: rgb(119, 80, 57);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    栗壳
                </h3>
                <div class="color__hex">#775039</div>
                <div class="color__rgb">RGB(119, 80, 57)</div>
                <div class="color__cmyk">CMYK(55,70,80,20)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5F4321"
                data-cmyk-text="CMYK(60,70,95,35)"
                style="background-color: rgb(95, 67, 33);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    龙战
                </h3>
                <div class="color__hex">#5F4321</div>
                <div class="color__rgb">RGB(95, 67, 33)</div>
                <div class="color__cmyk">CMYK(60,70,95,35)</div>
            </div>

            <div
                class="color"
                data-hex-text="#422517"
                data-cmyk-text="CMYK(65,80,90,55)"
                style="background-color: rgb(66, 37, 23);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青骊
                </h3>
                <div class="color__hex">#422517</div>
                <div class="color__rgb">RGB(66, 37, 23)</div>
                <div class="color__cmyk">CMYK(65,80,90,55)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F3A694"
                data-cmyk-text="CMYK(0,45,35,0)"
                style="background-color: rgb(243, 166, 148);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    海天霞
                </h3>
                <div class="color__hex">#F3A694</div>
                <div class="color__rgb">RGB(243, 166, 148)</div>
                <div class="color__cmyk">CMYK(0,45,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EE7959"
                data-cmyk-text="CMYK(0,65,60,0)"
                style="background-color: rgb(238, 121, 89);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    缙云
                </h3>
                <div class="color__hex">#EE7959</div>
                <div class="color__rgb">RGB(238, 121, 89)</div>
                <div class="color__cmyk">CMYK(0,65,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BA5140"
                data-cmyk-text="CMYK(30,80,75,0)"
                style="background-color: rgb(186, 81, 64);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    纁黄
                </h3>
                <div class="color__hex">#BA5140</div>
                <div class="color__rgb">RGB(186, 81, 64)</div>
                <div class="color__cmyk">CMYK(30,80,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C12C1F"
                data-cmyk-text="CMYK(25,95,100,0)"
                style="background-color: rgb(193, 44, 31);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    珊瑚赫
                </h3>
                <div class="color__hex">#C12C1F</div>
                <div class="color__rgb">RGB(193, 44, 31)</div>
                <div class="color__cmyk">CMYK(25,95,100,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Rain-Water">
        <h2>雨水</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#F9D3E3"
                data-cmyk-text="CMYK(0,25,0,0)"
                style="background-color: rgb(249, 211, 227);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    盈盈
                </h3>
                <div class="color__hex">#F9D3E3</div>
                <div class="color__rgb">RGB(249, 211, 227)</div>
                <div class="color__cmyk">CMYK(0,25,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ECB0C1"
                data-cmyk-text="CMYK(5,40,10,0)"
                style="background-color: rgb(236, 176, 193);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    水红
                </h3>
                <div class="color__hex">#ECB0C1</div>
                <div class="color__rgb">RGB(236, 176, 193)</div>
                <div class="color__cmyk">CMYK(5,40,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DD7694"
                data-cmyk-text="CMYK(10,65,20,0)"
                style="background-color: rgb(221, 118, 148);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苏梅
                </h3>
                <div class="color__hex">#DD7694</div>
                <div class="color__rgb">RGB(221, 118, 148)</div>
                <div class="color__cmyk">CMYK(10,65,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A76283"
                data-cmyk-text="CMYK(40,70,30,0)"
                style="background-color: rgb(167, 98, 131);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫茎屏风
                </h3>
                <div class="color__hex">#A76283</div>
                <div class="color__rgb">RGB(167, 98, 131)</div>
                <div class="color__cmyk">CMYK(40,70,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BEB1AA"
                data-cmyk-text="CMYK(30,30,30,0)"
                style="background-color: rgb(190, 177, 170);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    葭灰
                </h3>
                <div class="color__hex">#BEB1AA</div>
                <div class="color__rgb">RGB(190, 177, 170)</div>
                <div class="color__cmyk">CMYK(30,30,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B49273"
                data-cmyk-text="CMYK(35,45,55,0)"
                style="background-color: rgb(180, 146, 115);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄埃
                </h3>
                <div class="color__hex">#B49273</div>
                <div class="color__rgb">RGB(180, 146, 115)</div>
                <div class="color__cmyk">CMYK(35,45,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A46244"
                data-cmyk-text="CMYK(40,70,75,5)"
                style="background-color: rgb(164, 98, 68);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    老僧衣
                </h3>
                <div class="color__hex">#A46244</div>
                <div class="color__rgb">RGB(164, 98, 68)</div>
                <div class="color__cmyk">CMYK(40,70,75,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6B5458"
                data-cmyk-text="CMYK(65,70,60,10)"
                style="background-color: rgb(107, 84, 88);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    玄天
                </h3>
                <div class="color__hex">#6B5458</div>
                <div class="color__rgb">RGB(107, 84, 88)</div>
                <div class="color__cmyk">CMYK(65,70,60,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E5A84B"
                data-cmyk-text="CMYK(10,40,75,0)"
                style="background-color: rgb(229, 168, 75);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄河琉璃
                </h3>
                <div class="color__hex">#E5A84B</div>
                <div class="color__rgb">RGB(229, 168, 75)</div>
                <div class="color__cmyk">CMYK(10,40,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E18A3B"
                data-cmyk-text="CMYK(10,55,80,0)"
                style="background-color: rgb(225, 138, 59);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    库金
                </h3>
                <div class="color__hex">#E18A3B</div>
                <div class="color__rgb">RGB(225, 138, 59)</div>
                <div class="color__cmyk">CMYK(10,55,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#984F31"
                data-cmyk-text="CMYK(40,75,85,15)"
                style="background-color: rgb(152, 79, 49);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    缊韨
                </h3>
                <div class="color__hex">#984F31</div>
                <div class="color__rgb">RGB(152, 79, 49)</div>
                <div class="color__cmyk">CMYK(40,75,85,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7C461E"
                data-cmyk-text="CMYK(50,75,100,25)"
                style="background-color: rgb(124, 70, 30);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫瓯
                </h3>
                <div class="color__hex">#7C461E</div>
                <div class="color__rgb">RGB(124, 70, 30)</div>
                <div class="color__cmyk">CMYK(50,75,100,25)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C0D695"
                data-cmyk-text="CMYK(30,5,50,0)"
                style="background-color: rgb(192, 214, 149);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    欧碧
                </h3>
                <div class="color__hex">#C0D695</div>
                <div class="color__rgb">RGB(192, 214, 149)</div>
                <div class="color__cmyk">CMYK(30,5,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A9BE7B"
                data-cmyk-text="CMYK(40,15,60,0)"
                style="background-color: rgb(169, 190, 123);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    春辰
                </h3>
                <div class="color__hex">#A9BE7B</div>
                <div class="color__rgb">RGB(169, 190, 123)</div>
                <div class="color__cmyk">CMYK(40,15,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#779649"
                data-cmyk-text="CMYK(60,30,85,0)"
                style="background-color: rgb(119, 150, 73);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    碧山
                </h3>
                <div class="color__hex">#779649</div>
                <div class="color__rgb">RGB(119, 150, 73)</div>
                <div class="color__cmyk">CMYK(60,30,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4F6F46"
                data-cmyk-text="CMYK(75,50,85,5)"
                style="background-color: rgb(79, 111, 70);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青青
                </h3>
                <div class="color__hex">#4F6F46</div>
                <div class="color__rgb">RGB(79, 111, 70)</div>
                <div class="color__cmyk">CMYK(75,50,85,5)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Insects-Awakening">
        <h2>惊蛰</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#BA5B49"
                data-cmyk-text="CMYK(30,75,70,0)"
                style="background-color: rgb(186, 91, 73);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赤缇
                </h3>
                <div class="color__hex">#BA5B49</div>
                <div class="color__rgb">RGB(186, 91, 73)</div>
                <div class="color__cmyk">CMYK(30,75,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A64036"
                data-cmyk-text="CMYK(35,85,80,10)"
                style="background-color: rgb(166, 64, 54);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱草
                </h3>
                <div class="color__hex">#A64036</div>
                <div class="color__rgb">RGB(166, 64, 54)</div>
                <div class="color__cmyk">CMYK(35,85,80,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9E2A22"
                data-cmyk-text="CMYK(40,95,100,10)"
                style="background-color: rgb(158, 42, 34);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    綪茷
                </h3>
                <div class="color__hex">#9E2A22</div>
                <div class="color__rgb">RGB(158, 42, 34)</div>
                <div class="color__cmyk">CMYK(40,95,100,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7C191E"
                data-cmyk-text="CMYK(50,100,100,25)"
                style="background-color: rgb(124, 25, 30);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    顺圣
                </h3>
                <div class="color__hex">#7C191E</div>
                <div class="color__rgb">RGB(124, 25, 30)</div>
                <div class="color__cmyk">CMYK(50,100,100,25)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F6BEC8"
                data-cmyk-text="CMYK(0,35,10,0)"
                style="background-color: rgb(246, 190, 200);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    桃夭
                </h3>
                <div class="color__hex">#F6BEC8</div>
                <div class="color__rgb">RGB(246, 190, 200)</div>
                <div class="color__cmyk">CMYK(0,35,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F091A0"
                data-cmyk-text="CMYK(0,55,20,0)"
                style="background-color: rgb(240, 145, 160);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    杨妃
                </h3>
                <div class="color__hex">#F091A0</div>
                <div class="color__rgb">RGB(240, 145, 160)</div>
                <div class="color__cmyk">CMYK(0,55,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DC6B82"
                data-cmyk-text="CMYK(10,70,30,0)"
                style="background-color: rgb(220, 107, 130);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    长春
                </h3>
                <div class="color__hex">#DC6B82</div>
                <div class="color__rgb">RGB(220, 107, 130)</div>
                <div class="color__cmyk">CMYK(10,70,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C35C5D"
                data-cmyk-text="CMYK(25,75,55,0)"
                style="background-color: rgb(195, 92, 93);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    牙绯
                </h3>
                <div class="color__hex">#C35C5D</div>
                <div class="color__rgb">RGB(195, 92, 93)</div>
                <div class="color__cmyk">CMYK(25,75,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#FEDC5E"
                data-cmyk-text="CMYK(0,15,70,0)"
                style="background-color: rgb(254, 220, 94);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄栗留
                </h3>
                <div class="color__hex">#FEDC5E</div>
                <div class="color__rgb">RGB(254, 220, 94)</div>
                <div class="color__cmyk">CMYK(0,15,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#FAC03D"
                data-cmyk-text="CMYK(0,30,80,0)"
                style="background-color: rgb(250, 192, 61);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    栀子
                </h3>
                <div class="color__hex">#FAC03D</div>
                <div class="color__rgb">RGB(250, 192, 61)</div>
                <div class="color__cmyk">CMYK(0,30,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DB9B34"
                data-cmyk-text="CMYK(15,45,85,0)"
                style="background-color: rgb(219, 155, 52);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄不老
                </h3>
                <div class="color__hex">#DB9B34</div>
                <div class="color__rgb">RGB(219, 155, 52)</div>
                <div class="color__cmyk">CMYK(15,45,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C67915"
                data-cmyk-text="CMYK(25,60,100,0)"
                style="background-color: rgb(198, 121, 21);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    柘黄
                </h3>
                <div class="color__hex">#C67915</div>
                <div class="color__rgb">RGB(198, 121, 21)</div>
                <div class="color__cmyk">CMYK(25,60,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9AA7B1"
                data-cmyk-text="CMYK(45,30,25,0)"
                style="background-color: rgb(154, 167, 177);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青鸾
                </h3>
                <div class="color__hex">#9AA7B1</div>
                <div class="color__rgb">RGB(154, 167, 177)</div>
                <div class="color__cmyk">CMYK(45,30,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6B798E"
                data-cmyk-text="CMYK(65,50,35,0)"
                style="background-color: rgb(107, 121, 142);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    菘蓝
                </h3>
                <div class="color__hex">#6B798E</div>
                <div class="color__rgb">RGB(107, 121, 142)</div>
                <div class="color__cmyk">CMYK(65,50,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#45465E"
                data-cmyk-text="CMYK(80,75,50,15)"
                style="background-color: rgb(69, 70, 94);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青黛
                </h3>
                <div class="color__hex">#45465E</div>
                <div class="color__rgb">RGB(69, 70, 94)</div>
                <div class="color__cmyk">CMYK(80,75,50,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#2C2F3B"
                data-cmyk-text="CMYK(85,80,65,40)"
                style="background-color: rgb(44, 47, 59);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绀蝶
                </h3>
                <div class="color__hex">#2C2F3B</div>
                <div class="color__rgb">RGB(44, 47, 59)</div>
                <div class="color__cmyk">CMYK(85,80,65,40)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Spring-Equinox">
        <h2>春分</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#EBEEE8"
                data-cmyk-text="CMYK(10,5,10,0)"
                style="background-color: rgb(235, 238, 232);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    皦玉
                </h3>
                <div class="color__hex">#EBEEE8</div>
                <div class="color__rgb">RGB(235, 238, 232)</div>
                <div class="color__cmyk">CMYK(10,5,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EBEDDF"
                data-cmyk-text="CMYK(10,5,15,0)"
                style="background-color: rgb(235, 237, 223);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    吉量
                </h3>
                <div class="color__hex">#EBEDDF</div>
                <div class="color__rgb">RGB(235, 237, 223)</div>
                <div class="color__cmyk">CMYK(10,5,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E0E0D0"
                data-cmyk-text="CMYK(15,10,20,0)"
                style="background-color: rgb(224, 224, 208);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    韶粉
                </h3>
                <div class="color__hex">#E0E0D0</div>
                <div class="color__rgb">RGB(224, 224, 208)</div>
                <div class="color__cmyk">CMYK(15,10,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C7C6B6"
                data-cmyk-text="CMYK(20,15,25,10)"
                style="background-color: rgb(199, 198, 182);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    霜地
                </h3>
                <div class="color__hex">#C7C6B6</div>
                <div class="color__rgb">RGB(199, 198, 182)</div>
                <div class="color__cmyk">CMYK(20,15,25,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D2AF9D"
                data-cmyk-text="CMYK(20,35,35,0)"
                style="background-color: rgb(210, 175, 157);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    夏籥
                </h3>
                <div class="color__hex">#D2AF9D</div>
                <div class="color__rgb">RGB(210, 175, 157)</div>
                <div class="color__cmyk">CMYK(20,35,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BC836B"
                data-cmyk-text="CMYK(30,55,55,0)"
                style="background-color: rgb(188, 131, 107);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫磨金
                </h3>
                <div class="color__hex">#BC836B</div>
                <div class="color__rgb">RGB(188, 131, 107)</div>
                <div class="color__cmyk">CMYK(30,55,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B26D5D"
                data-cmyk-text="CMYK(35,65,60,0)"
                style="background-color: rgb(178, 109, 93);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    檀色
                </h3>
                <div class="color__hex">#B26D5D</div>
                <div class="color__rgb">RGB(178, 109, 93)</div>
                <div class="color__cmyk">CMYK(35,65,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9A6655"
                data-cmyk-text="CMYK(45,65,65,5)"
                style="background-color: rgb(154, 102, 85);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赭罗
                </h3>
                <div class="color__hex">#9A6655</div>
                <div class="color__rgb">RGB(154, 102, 85)</div>
                <div class="color__cmyk">CMYK(45,65,65,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EA5514"
                data-cmyk-text="CMYK(0,80,95,0)"
                style="background-color: rgb(234, 85, 20);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄丹
                </h3>
                <div class="color__hex">#EA5514</div>
                <div class="color__rgb">RGB(234, 85, 20)</div>
                <div class="color__cmyk">CMYK(0,80,95,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D23918"
                data-cmyk-text="CMYK(15,90,100,0)"
                style="background-color: rgb(210, 57, 24);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    洛神珠
                </h3>
                <div class="color__hex">#D23918</div>
                <div class="color__rgb">RGB(210, 57, 24)</div>
                <div class="color__cmyk">CMYK(15,90,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C8161D"
                data-cmyk-text="CMYK(20,100,100,0)"
                style="background-color: rgb(200, 22, 29);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    丹雘
                </h3>
                <div class="color__hex">#C8161D</div>
                <div class="color__rgb">RGB(200, 22, 29)</div>
                <div class="color__cmyk">CMYK(20,100,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A72126"
                data-cmyk-text="CMYK(40,100,100,0)"
                style="background-color: rgb(167, 33, 38);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    水华朱
                </h3>
                <div class="color__hex">#A72126</div>
                <div class="color__rgb">RGB(167, 33, 38)</div>
                <div class="color__cmyk">CMYK(40,100,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#3271AE"
                data-cmyk-text="CMYK(80,50,10,0)"
                style="background-color: rgb(50, 113, 174);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青冥
                </h3>
                <div class="color__hex">#3271AE</div>
                <div class="color__rgb">RGB(50, 113, 174)</div>
                <div class="color__cmyk">CMYK(80,50,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#007175"
                data-cmyk-text="CMYK(95,45,55,0)"
                style="background-color: rgb(0, 113, 117);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青雘
                </h3>
                <div class="color__hex">#007175</div>
                <div class="color__rgb">RGB(0, 113, 117)</div>
                <div class="color__cmyk">CMYK(95,45,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#284852"
                data-cmyk-text="CMYK(90,75,65,10)"
                style="background-color: rgb(40, 72, 82);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青緺
                </h3>
                <div class="color__hex">#284852</div>
                <div class="color__rgb">RGB(40, 72, 82)</div>
                <div class="color__cmyk">CMYK(90,75,65,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#12264F"
                data-cmyk-text="CMYK(100,95,50,25)"
                style="background-color: rgb(18, 38, 79);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    骐驎
                </h3>
                <div class="color__hex">#12264F</div>
                <div class="color__rgb">RGB(18, 38, 79)</div>
                <div class="color__cmyk">CMYK(100,95,50,25)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Fresh-Green">
        <h2>清明</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#A6559D"
                data-cmyk-text="CMYK(40,75,0,0)"
                style="background-color: rgb(166, 85, 157);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫蒲
                </h3>
                <div class="color__hex">#A6559D</div>
                <div class="color__rgb">RGB(166, 85, 157)</div>
                <div class="color__cmyk">CMYK(40,75,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8A1874"
                data-cmyk-text="CMYK(55,100,20,0)"
                style="background-color: rgb(138, 24, 116);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赪紫
                </h3>
                <div class="color__hex">#8A1874</div>
                <div class="color__rgb">RGB(138, 24, 116)</div>
                <div class="color__cmyk">CMYK(55,100,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6C216D"
                data-cmyk-text="CMYK(70,100,30,0)"
                style="background-color: rgb(108, 33, 109);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    齐紫
                </h3>
                <div class="color__hex">#6C216D</div>
                <div class="color__rgb">RGB(108, 33, 109)</div>
                <div class="color__cmyk">CMYK(70,100,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#422256"
                data-cmyk-text="CMYK(85,100,45,15)"
                style="background-color: rgb(66, 34, 86);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    凝夜紫
                </h3>
                <div class="color__hex">#422256</div>
                <div class="color__rgb">RGB(66, 34, 86)</div>
                <div class="color__cmyk">CMYK(85,100,45,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BEC2B3"
                data-cmyk-text="CMYK(30,20,30,0)"
                style="background-color: rgb(190, 194, 179);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    冻缥
                </h3>
                <div class="color__hex">#BEC2B3</div>
                <div class="color__rgb">RGB(190, 194, 179)</div>
                <div class="color__cmyk">CMYK(30,20,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9D9D82"
                data-cmyk-text="CMYK(45,35,50,0)"
                style="background-color: rgb(157, 157, 130);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    春碧
                </h3>
                <div class="color__hex">#9D9D82</div>
                <div class="color__rgb">RGB(157, 157, 130)</div>
                <div class="color__cmyk">CMYK(45,35,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#919177"
                data-cmyk-text="CMYK(50,40,55,0)"
                style="background-color: rgb(145, 145, 119);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    执大象
                </h3>
                <div class="color__hex">#919177</div>
                <div class="color__rgb">RGB(145, 145, 119)</div>
                <div class="color__cmyk">CMYK(50,40,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#79836C"
                data-cmyk-text="CMYK(60,45,60,0)"
                style="background-color: rgb(121, 131, 108);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苔古
                </h3>
                <div class="color__hex">#79836C</div>
                <div class="color__rgb">RGB(121, 131, 108)</div>
                <div class="color__cmyk">CMYK(60,45,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D3CCD6"
                data-cmyk-text="CMYK(20,20,10,0)"
                style="background-color: rgb(211, 204, 214);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    香炉紫烟
                </h3>
                <div class="color__hex">#D3CCD6</div>
                <div class="color__rgb">RGB(211, 204, 214)</div>
                <div class="color__cmyk">CMYK(20,20,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9B8EA9"
                data-cmyk-text="CMYK(45,45,20,0)"
                style="background-color: rgb(155, 142, 169);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫菂
                </h3>
                <div class="color__hex">#9B8EA9</div>
                <div class="color__rgb">RGB(155, 142, 169)</div>
                <div class="color__cmyk">CMYK(45,45,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7E527F"
                data-cmyk-text="CMYK(60,75,30,0)"
                style="background-color: rgb(126, 82, 127);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    拂紫绵
                </h3>
                <div class="color__hex">#7E527F</div>
                <div class="color__rgb">RGB(126, 82, 127)</div>
                <div class="color__cmyk">CMYK(60,75,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#663D74"
                data-cmyk-text="CMYK(70,85,30,5)"
                style="background-color: rgb(102, 61, 116);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    三公子
                </h3>
                <div class="color__hex">#663D74</div>
                <div class="color__rgb">RGB(102, 61, 116)</div>
                <div class="color__cmyk">CMYK(70,85,30,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CB5C83"
                data-cmyk-text="CMYK(20,75,25,0)"
                style="background-color: rgb(203, 92, 131);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    琅玕紫
                </h3>
                <div class="color__hex">#CB5C83</div>
                <div class="color__rgb">RGB(203, 92, 131)</div>
                <div class="color__cmyk">CMYK(20,75,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B83570"
                data-cmyk-text="CMYK(30,90,30,0)"
                style="background-color: rgb(184, 53, 112);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    红踯躅
                </h3>
                <div class="color__hex">#B83570</div>
                <div class="color__rgb">RGB(184, 53, 112)</div>
                <div class="color__cmyk">CMYK(30,90,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A73766"
                data-cmyk-text="CMYK(40,90,40,0)"
                style="background-color: rgb(167, 55, 102);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    魏红
                </h3>
                <div class="color__hex">#A73766</div>
                <div class="color__rgb">RGB(167, 55, 102)</div>
                <div class="color__cmyk">CMYK(40,90,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#903754"
                data-cmyk-text="CMYK(50,90,55,5)"
                style="background-color: rgb(144, 55, 84);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    魏紫
                </h3>
                <div class="color__hex">#903754</div>
                <div class="color__rgb">RGB(144, 55, 84)</div>
                <div class="color__cmyk">CMYK(50,90,55,5)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Grain-Rain">
        <h2>谷雨</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#DCC7E1"
                data-cmyk-text="CMYK(15,25,0,0)"
                style="background-color: rgb(220, 199, 225);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    昌荣
                </h3>
                <div class="color__hex">#DCC7E1</div>
                <div class="color__rgb">RGB(220, 199, 225)</div>
                <div class="color__cmyk">CMYK(15,25,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BBA1CB"
                data-cmyk-text="CMYK(30,40,0,0)"
                style="background-color: rgb(187, 161, 203);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫薄汗
                </h3>
                <div class="color__hex">#BBA1CB</div>
                <div class="color__rgb">RGB(187, 161, 203)</div>
                <div class="color__cmyk">CMYK(30,40,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A67EB7"
                data-cmyk-text="CMYK(40,55,0,0)"
                style="background-color: rgb(166, 126, 183);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    茈藐
                </h3>
                <div class="color__hex">#A67EB7</div>
                <div class="color__rgb">RGB(166, 126, 183)</div>
                <div class="color__cmyk">CMYK(40,55,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7D5284"
                data-cmyk-text="CMYK(60,75,25,0)"
                style="background-color: rgb(125, 82, 132);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫紶
                </h3>
                <div class="color__hex">#7D5284</div>
                <div class="color__rgb">RGB(125, 82, 132)</div>
                <div class="color__cmyk">CMYK(60,75,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A8BF8F"
                data-cmyk-text="CMYK(40,15,50,0)"
                style="background-color: rgb(168, 191, 143);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苍葭
                </h3>
                <div class="color__hex">#A8BF8F</div>
                <div class="color__rgb">RGB(168, 191, 143)</div>
                <div class="color__cmyk">CMYK(40,15,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#68945C"
                data-cmyk-text="CMYK(65,30,75,0)"
                style="background-color: rgb(104, 148, 92);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    庭芜绿
                </h3>
                <div class="color__hex">#68945C</div>
                <div class="color__rgb">RGB(104, 148, 92)</div>
                <div class="color__cmyk">CMYK(65,30,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4C8045"
                data-cmyk-text="CMYK(75,40,90,0)"
                style="background-color: rgb(76, 128, 69);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    翠微
                </h3>
                <div class="color__hex">#4C8045</div>
                <div class="color__rgb">RGB(76, 128, 69)</div>
                <div class="color__cmyk">CMYK(75,40,90,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#446A37"
                data-cmyk-text="CMYK(80,55,100,0)"
                style="background-color: rgb(68, 106, 55);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    翠虬
                </h3>
                <div class="color__hex">#446A37</div>
                <div class="color__rgb">RGB(68, 106, 55)</div>
                <div class="color__cmyk">CMYK(80,55,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#AED0EE"
                data-cmyk-text="CMYK(35,10,0,0)"
                style="background-color: rgb(174, 208, 238);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    碧落
                </h3>
                <div class="color__hex">#AED0EE</div>
                <div class="color__rgb">RGB(174, 208, 238)</div>
                <div class="color__cmyk">CMYK(35,10,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6E9BC5"
                data-cmyk-text="CMYK(60,30,10,0)"
                style="background-color: rgb(110, 155, 197);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    挼蓝
                </h3>
                <div class="color__hex">#6E9BC5</div>
                <div class="color__rgb">RGB(110, 155, 197)</div>
                <div class="color__cmyk">CMYK(60,30,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#354E6B"
                data-cmyk-text="CMYK(85,70,45,10)"
                style="background-color: rgb(53, 78, 107);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青雀头黛
                </h3>
                <div class="color__hex">#354E6B</div>
                <div class="color__rgb">RGB(53, 78, 107)</div>
                <div class="color__cmyk">CMYK(85,70,45,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#13393E"
                data-cmyk-text="CMYK(95,80,75,25)"
                style="background-color: rgb(19, 57, 62);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    螺子黛
                </h3>
                <div class="color__hex">#13393E</div>
                <div class="color__rgb">RGB(19, 57, 62)</div>
                <div class="color__cmyk">CMYK(95,80,75,25)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BD8253"
                data-cmyk-text="CMYK(30,55,70,0)"
                style="background-color: rgb(189, 130, 83);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    露褐
                </h3>
                <div class="color__hex">#BD8253</div>
                <div class="color__rgb">RGB(189, 130, 83)</div>
                <div class="color__cmyk">CMYK(30,55,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#945635"
                data-cmyk-text="CMYK(50,75,90,0)"
                style="background-color: rgb(148, 86, 53);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    檀褐
                </h3>
                <div class="color__hex">#945635</div>
                <div class="color__rgb">RGB(148, 86, 53)</div>
                <div class="color__cmyk">CMYK(50,75,90,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#804C2E"
                data-cmyk-text="CMYK(60,80,100,0)"
                style="background-color: rgb(128, 76, 46);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    緅絺
                </h3>
                <div class="color__hex">#804C2E</div>
                <div class="color__rgb">RGB(128, 76, 46)</div>
                <div class="color__cmyk">CMYK(60,80,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5B3222"
                data-cmyk-text="CMYK(60,80,90,40)"
                style="background-color: rgb(91, 50, 34);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    目童子
                </h3>
                <div class="color__hex">#5B3222</div>
                <div class="color__rgb">RGB(91, 50, 34)</div>
                <div class="color__cmyk">CMYK(60,80,90,40)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Beginning-of-Summer">
        <h2>立夏</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#C3D94E"
                data-cmyk-text="CMYK(30,0,80,0)"
                style="background-color: rgb(195, 217, 78);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青粲
                </h3>
                <div class="color__hex">#C3D94E</div>
                <div class="color__rgb">RGB(195, 217, 78)</div>
                <div class="color__cmyk">CMYK(30,0,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B7D332"
                data-cmyk-text="CMYK(35,0,90,0)"
                style="background-color: rgb(183, 211, 50);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    翠缥
                </h3>
                <div class="color__hex">#B7D332</div>
                <div class="color__rgb">RGB(183, 211, 50)</div>
                <div class="color__cmyk">CMYK(35,0,90,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9EBC19"
                data-cmyk-text="CMYK(45,10,100,0)"
                style="background-color: rgb(158, 188, 25);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    人籁
                </h3>
                <div class="color__hex">#9EBC19</div>
                <div class="color__rgb">RGB(158, 188, 25)</div>
                <div class="color__cmyk">CMYK(45,10,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#84A729"
                data-cmyk-text="CMYK(55,20,100,0)"
                style="background-color: rgb(132, 167, 41);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    水龙吟
                </h3>
                <div class="color__hex">#84A729</div>
                <div class="color__rgb">RGB(132, 167, 41)</div>
                <div class="color__cmyk">CMYK(55,20,100,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DFCEB4"
                data-cmyk-text="CMYK(15,20,30,0)"
                style="background-color: rgb(223, 206, 180);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    地籁
                </h3>
                <div class="color__hex">#DFCEB4</div>
                <div class="color__rgb">RGB(223, 206, 180)</div>
                <div class="color__cmyk">CMYK(15,20,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BFA782"
                data-cmyk-text="CMYK(30,35,50,0)"
                style="background-color: rgb(191, 167, 130);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    大块
                </h3>
                <div class="color__hex">#BFA782</div>
                <div class="color__rgb">RGB(191, 167, 130)</div>
                <div class="color__cmyk">CMYK(30,35,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B49B7F"
                data-cmyk-text="CMYK(35,40,50,0)"
                style="background-color: rgb(180, 155, 127);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    养生主
                </h3>
                <div class="color__hex">#B49B7F</div>
                <div class="color__rgb">RGB(180, 155, 127)</div>
                <div class="color__cmyk">CMYK(35,40,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#94784F"
                data-cmyk-text="CMYK(50,55,75,0)"
                style="background-color: rgb(148, 120, 79);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    大云
                </h3>
                <div class="color__hex">#94784F</div>
                <div class="color__rgb">RGB(148, 120, 79)</div>
                <div class="color__cmyk">CMYK(50,55,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BEC2BC"
                data-cmyk-text="CMYK(30,20,25,0)"
                style="background-color: rgb(190, 194, 188);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    溶溶月
                </h3>
                <div class="color__hex">#BEC2BC</div>
                <div class="color__rgb">RGB(190, 194, 188)</div>
                <div class="color__cmyk">CMYK(30,20,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A8A19C"
                data-cmyk-text="CMYK(40,35,35,0)"
                style="background-color: rgb(168, 161, 156);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绍衣
                </h3>
                <div class="color__hex">#A8A19C</div>
                <div class="color__rgb">RGB(168, 161, 156)</div>
                <div class="color__cmyk">CMYK(40,35,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#92897B"
                data-cmyk-text="CMYK(50,45,50,0)"
                style="background-color: rgb(146, 137, 123);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石莲褐
                </h3>
                <div class="color__hex">#92897B</div>
                <div class="color__rgb">RGB(146, 137, 123)</div>
                <div class="color__cmyk">CMYK(50,45,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#70695D"
                data-cmyk-text="CMYK(65,60,65,0)"
                style="background-color: rgb(112, 105, 93);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黑朱
                </h3>
                <div class="color__hex">#70695D</div>
                <div class="color__rgb">RGB(112, 105, 93)</div>
                <div class="color__cmyk">CMYK(65,60,65,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F29A76"
                data-cmyk-text="CMYK(0,50,50,0)"
                style="background-color: rgb(242, 154, 118);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱颜酡
                </h3>
                <div class="color__hex">#F29A76</div>
                <div class="color__rgb">RGB(242, 154, 118)</div>
                <div class="color__cmyk">CMYK(0,50,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ED6D3D"
                data-cmyk-text="CMYK(0,70,75,0)"
                style="background-color: rgb(237, 109, 61);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苕荣
                </h3>
                <div class="color__hex">#ED6D3D</div>
                <div class="color__rgb">RGB(237, 109, 61)</div>
                <div class="color__cmyk">CMYK(0,70,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E94829"
                data-cmyk-text="CMYK(0,85,85,0)"
                style="background-color: rgb(233, 72, 41);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    檎丹
                </h3>
                <div class="color__hex">#E94829</div>
                <div class="color__rgb">RGB(233, 72, 41)</div>
                <div class="color__cmyk">CMYK(0,85,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E60012"
                data-cmyk-text="CMYK(0,100,100,0)"
                style="background-color: rgb(230, 0, 18);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    丹罽
                </h3>
                <div class="color__hex">#E60012</div>
                <div class="color__rgb">RGB(230, 0, 18)</div>
                <div class="color__cmyk">CMYK(0,100,100,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Lesser-Fullness">
        <h2>小满</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#E2A2AC"
                data-cmyk-text="CMYK(10,45,20,0)"
                style="background-color: rgb(226, 162, 172);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    彤管
                </h3>
                <div class="color__hex">#E2A2AC</div>
                <div class="color__rgb">RGB(226, 162, 172)</div>
                <div class="color__cmyk">CMYK(10,45,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DD6B7B"
                data-cmyk-text="CMYK(10,70,35,0)"
                style="background-color: rgb(221, 107, 123);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    渥赭
                </h3>
                <div class="color__hex">#DD6B7B</div>
                <div class="color__rgb">RGB(221, 107, 123)</div>
                <div class="color__cmyk">CMYK(10,70,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C25160"
                data-cmyk-text="CMYK(25,80,50,0)"
                style="background-color: rgb(194, 81, 96);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    唇脂
                </h3>
                <div class="color__hex">#C25160</div>
                <div class="color__rgb">RGB(194, 81, 96)</div>
                <div class="color__cmyk">CMYK(25,80,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B81A35"
                data-cmyk-text="CMYK(30,100,80,0)"
                style="background-color: rgb(184, 26, 53);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱孔阳
                </h3>
                <div class="color__hex">#B81A35</div>
                <div class="color__rgb">RGB(184, 26, 53)</div>
                <div class="color__cmyk">CMYK(30,100,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6A8D52"
                data-cmyk-text="CMYK(65,35,80,0)"
                style="background-color: rgb(106, 141, 82);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石发
                </h3>
                <div class="color__hex">#6A8D52</div>
                <div class="color__rgb">RGB(106, 141, 82)</div>
                <div class="color__cmyk">CMYK(65,35,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5D8351"
                data-cmyk-text="CMYK(70,40,80,0)"
                style="background-color: rgb(93, 131, 81);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    漆姑
                </h3>
                <div class="color__hex">#5D8351</div>
                <div class="color__rgb">RGB(93, 131, 81)</div>
                <div class="color__cmyk">CMYK(70,40,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4F794A"
                data-cmyk-text="CMYK(75,45,85,0)"
                style="background-color: rgb(79, 121, 74);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    芰荷
                </h3>
                <div class="color__hex">#4F794A</div>
                <div class="color__rgb">RGB(79, 121, 74)</div>
                <div class="color__cmyk">CMYK(75,45,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#2A6E3F"
                data-cmyk-text="CMYK(85,50,95,0)"
                style="background-color: rgb(42, 110, 63);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    官绿
                </h3>
                <div class="color__hex">#2A6E3F</div>
                <div class="color__rgb">RGB(42, 110, 63)</div>
                <div class="color__cmyk">CMYK(85,50,95,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D4C9AA"
                data-cmyk-text="CMYK(20,20,35,0)"
                style="background-color: rgb(212, 201, 170);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    仙米
                </h3>
                <div class="color__hex">#D4C9AA</div>
                <div class="color__rgb">RGB(212, 201, 170)</div>
                <div class="color__cmyk">CMYK(20,20,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B4A379"
                data-cmyk-text="CMYK(35,35,55,0)"
                style="background-color: rgb(180, 163, 121);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄螺
                </h3>
                <div class="color__hex">#B4A379</div>
                <div class="color__rgb">RGB(180, 163, 121)</div>
                <div class="color__cmyk">CMYK(35,35,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9E8358"
                data-cmyk-text="CMYK(45,50,70,0)"
                style="background-color: rgb(158, 131, 88);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    降真香
                </h3>
                <div class="color__hex">#9E8358</div>
                <div class="color__rgb">RGB(158, 131, 88)</div>
                <div class="color__cmyk">CMYK(45,50,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#81663B"
                data-cmyk-text="CMYK(55,60,85,10)"
                style="background-color: rgb(129, 102, 59);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    远志
                </h3>
                <div class="color__hex">#81663B</div>
                <div class="color__rgb">RGB(129, 102, 59)</div>
                <div class="color__cmyk">CMYK(55,60,85,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F2C867"
                data-cmyk-text="CMYK(5,25,65,0)"
                style="background-color: rgb(242, 200, 103);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    嫩鹅黄
                </h3>
                <div class="color__hex">#F2C867</div>
                <div class="color__rgb">RGB(242, 200, 103)</div>
                <div class="color__cmyk">CMYK(5,25,65,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D3A237"
                data-cmyk-text="CMYK(20,40,85,0)"
                style="background-color: rgb(211, 162, 55);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鞠衣
                </h3>
                <div class="color__hex">#D3A237</div>
                <div class="color__rgb">RGB(211, 162, 55)</div>
                <div class="color__cmyk">CMYK(20,40,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D08635"
                data-cmyk-text="CMYK(20,55,85,0)"
                style="background-color: rgb(208, 134, 53);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    郁金裙
                </h3>
                <div class="color__hex">#D08635</div>
                <div class="color__rgb">RGB(208, 134, 53)</div>
                <div class="color__cmyk">CMYK(20,55,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9F6027"
                data-cmyk-text="CMYK(45,70,100,0)"
                style="background-color: rgb(159, 96, 39);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄流
                </h3>
                <div class="color__hex">#9F6027</div>
                <div class="color__rgb">RGB(159, 96, 39)</div>
                <div class="color__cmyk">CMYK(45,70,100,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Grain-in-Ear">
        <h2>芒种</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#D5D1AE"
                data-cmyk-text="CMYK(20,15,35,0)"
                style="background-color: rgb(213, 209, 174);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    筠雾
                </h3>
                <div class="color__hex">#D5D1AE</div>
                <div class="color__rgb">RGB(213, 209, 174)</div>
                <div class="color__cmyk">CMYK(20,15,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BFC096"
                data-cmyk-text="CMYK(30,20,45,0)"
                style="background-color: rgb(191, 192, 150);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    瓷秘
                </h3>
                <div class="color__hex">#BFC096</div>
                <div class="color__rgb">RGB(191, 192, 150)</div>
                <div class="color__cmyk">CMYK(30,20,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A9A886"
                data-cmyk-text="CMYK(40,30,50,0)"
                style="background-color: rgb(169, 168, 134);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    琬琰
                </h3>
                <div class="color__hex">#A9A886</div>
                <div class="color__rgb">RGB(169, 168, 134)</div>
                <div class="color__cmyk">CMYK(40,30,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#92905D"
                data-cmyk-text="CMYK(50,40,70,0)"
                style="background-color: rgb(146, 144, 93);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青圭
                </h3>
                <div class="color__hex">#92905D</div>
                <div class="color__rgb">RGB(146, 144, 93)</div>
                <div class="color__cmyk">CMYK(50,40,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B3B59C"
                data-cmyk-text="CMYK(35,25,40,0)"
                style="background-color: rgb(179, 181, 156);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鸣珂
                </h3>
                <div class="color__hex">#B3B59C</div>
                <div class="color__rgb">RGB(179, 181, 156)</div>
                <div class="color__cmyk">CMYK(35,25,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A8B092"
                data-cmyk-text="CMYK(40,25,45,0)"
                style="background-color: rgb(168, 176, 146);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青玉案
                </h3>
                <div class="color__hex">#A8B092</div>
                <div class="color__rgb">RGB(168, 176, 146)</div>
                <div class="color__cmyk">CMYK(40,25,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A9A773"
                data-cmyk-text="CMYK(40,30,60,0)"
                style="background-color: rgb(169, 167, 115);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    出岫
                </h3>
                <div class="color__hex">#A9A773</div>
                <div class="color__rgb">RGB(169, 167, 115)</div>
                <div class="color__cmyk">CMYK(40,30,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#868C4E"
                data-cmyk-text="CMYK(55,40,80,0)"
                style="background-color: rgb(134, 140, 78);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    风入松
                </h3>
                <div class="color__hex">#868C4E</div>
                <div class="color__rgb">RGB(134, 140, 78)</div>
                <div class="color__cmyk">CMYK(55,40,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DDBB99"
                data-cmyk-text="CMYK(15,30,40,0)"
                style="background-color: rgb(221, 187, 153);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    如梦令
                </h3>
                <div class="color__hex">#DDBB99</div>
                <div class="color__rgb">RGB(221, 187, 153)</div>
                <div class="color__cmyk">CMYK(15,30,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D2A36C"
                data-cmyk-text="CMYK(20,40,60,0)"
                style="background-color: rgb(210, 163, 108);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    芸黄
                </h3>
                <div class="color__hex">#D2A36C</div>
                <div class="color__rgb">RGB(210, 163, 108)</div>
                <div class="color__cmyk">CMYK(20,40,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BE9457"
                data-cmyk-text="CMYK(30,45,70,0)"
                style="background-color: rgb(190, 148, 87);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    金埒
                </h3>
                <div class="color__hex">#BE9457</div>
                <div class="color__rgb">RGB(190, 148, 87)</div>
                <div class="color__cmyk">CMYK(30,45,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B4884D"
                data-cmyk-text="CMYK(35,50,75,0)"
                style="background-color: rgb(180, 136, 77);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    雌黄
                </h3>
                <div class="color__hex">#B4884D</div>
                <div class="color__rgb">RGB(180, 136, 77)</div>
                <div class="color__cmyk">CMYK(35,50,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#535164"
                data-cmyk-text="CMYK(75,70,50,10)"
                style="background-color: rgb(83, 81, 100);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    曾青
                </h3>
                <div class="color__hex">#535164</div>
                <div class="color__rgb">RGB(83, 81, 100)</div>
                <div class="color__cmyk">CMYK(75,70,50,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#454659"
                data-cmyk-text="CMYK(80,75,55,15)"
                style="background-color: rgb(69, 70, 89);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    䒌靘
                </h3>
                <div class="color__hex">#454659</div>
                <div class="color__rgb">RGB(69, 70, 89)</div>
                <div class="color__cmyk">CMYK(80,75,55,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#343041"
                data-cmyk-text="CMYK(85,85,65,30)"
                style="background-color: rgb(52, 48, 65);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    璆琳
                </h3>
                <div class="color__hex">#343041</div>
                <div class="color__rgb">RGB(52, 48, 65)</div>
                <div class="color__cmyk">CMYK(85,85,65,30)</div>
            </div>

            <div
                class="color"
                data-hex-text="#1E2732"
                data-cmyk-text="CMYK(90,85,70,45)"
                style="background-color: rgb(30, 39, 50);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    瑾瑜
                </h3>
                <div class="color__hex">#1E2732</div>
                <div class="color__rgb">RGB(30, 39, 50)</div>
                <div class="color__cmyk">CMYK(90,85,70,45)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Summer-Solstice">
        <h2>夏至</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#CB523E"
                data-cmyk-text="CMYK(20,80,75,0)"
                style="background-color: rgb(203, 82, 62);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赩炽
                </h3>
                <div class="color__hex">#CB523E</div>
                <div class="color__rgb">RGB(203, 82, 62)</div>
                <div class="color__cmyk">CMYK(20,80,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B13B2E"
                data-cmyk-text="CMYK(35,90,90,0)"
                style="background-color: rgb(177, 59, 46);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石榴裙
                </h3>
                <div class="color__hex">#B13B2E</div>
                <div class="color__rgb">RGB(177, 59, 46)</div>
                <div class="color__cmyk">CMYK(35,90,90,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#95302E"
                data-cmyk-text="CMYK(50,95,95,0)"
                style="background-color: rgb(149, 48, 46);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱湛
                </h3>
                <div class="color__hex">#95302E</div>
                <div class="color__rgb">RGB(149, 48, 46)</div>
                <div class="color__cmyk">CMYK(50,95,95,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#822327"
                data-cmyk-text="CMYK(55,100,100,10)"
                style="background-color: rgb(130, 35, 39);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    大繎
                </h3>
                <div class="color__hex">#822327</div>
                <div class="color__rgb">RGB(130, 35, 39)</div>
                <div class="color__cmyk">CMYK(55,100,100,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B2B6B6"
                data-cmyk-text="CMYK(35,25,25,0)"
                style="background-color: rgb(178, 182, 182);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    月魄
                </h3>
                <div class="color__hex">#B2B6B6</div>
                <div class="color__rgb">RGB(178, 182, 182)</div>
                <div class="color__cmyk">CMYK(35,25,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A7AAA1"
                data-cmyk-text="CMYK(40,30,35,0)"
                style="background-color: rgb(167, 170, 161);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    不皂
                </h3>
                <div class="color__hex">#A7AAA1</div>
                <div class="color__rgb">RGB(167, 170, 161)</div>
                <div class="color__cmyk">CMYK(40,30,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7A7B78"
                data-cmyk-text="CMYK(60,50,50,0)"
                style="background-color: rgb(122, 123, 120);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    雷雨垂
                </h3>
                <div class="color__hex">#7A7B78</div>
                <div class="color__rgb">RGB(122, 123, 120)</div>
                <div class="color__cmyk">CMYK(60,50,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#686A67"
                data-cmyk-text="CMYK(65,55,55,10)"
                style="background-color: rgb(104, 106, 103);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石涅
                </h3>
                <div class="color__hex">#686A67</div>
                <div class="color__rgb">RGB(104, 106, 103)</div>
                <div class="color__cmyk">CMYK(65,55,55,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F0C2A2"
                data-cmyk-text="CMYK(5,30,35,0)"
                style="background-color: rgb(240, 194, 162);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    扶光
                </h3>
                <div class="color__hex">#F0C2A2</div>
                <div class="color__rgb">RGB(240, 194, 162)</div>
                <div class="color__cmyk">CMYK(5,30,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DB9C5E"
                data-cmyk-text="CMYK(15,45,65,0)"
                style="background-color: rgb(219, 156, 94);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    椒房
                </h3>
                <div class="color__hex">#DB9C5E</div>
                <div class="color__rgb">RGB(219, 156, 94)</div>
                <div class="color__cmyk">CMYK(15,45,65,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D9883D"
                data-cmyk-text="CMYK(15,55,80,0)"
                style="background-color: rgb(217, 136, 61);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    红友
                </h3>
                <div class="color__hex">#D9883D</div>
                <div class="color__rgb">RGB(217, 136, 61)</div>
                <div class="color__cmyk">CMYK(15,55,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CC5D20"
                data-cmyk-text="CMYK(20,75,95,0)"
                style="background-color: rgb(204, 93, 32);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    光明砂
                </h3>
                <div class="color__hex">#CC5D20</div>
                <div class="color__rgb">RGB(204, 93, 32)</div>
                <div class="color__cmyk">CMYK(20,75,95,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F5F3F2"
                data-cmyk-text="CMYK(5,5,5,0)"
                style="background-color: rgb(245, 243, 242);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    山矾
                </h3>
                <div class="color__hex">#F5F3F2</div>
                <div class="color__rgb">RGB(245, 243, 242)</div>
                <div class="color__cmyk">CMYK(5,5,5,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EAE5E3"
                data-cmyk-text="CMYK(10,10,10,0)"
                style="background-color: rgb(234, 229, 227);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    玉頩
                </h3>
                <div class="color__hex">#EAE5E3</div>
                <div class="color__rgb">RGB(234, 229, 227)</div>
                <div class="color__cmyk">CMYK(10,10,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DFE0D9"
                data-cmyk-text="CMYK(15,10,15,0)"
                style="background-color: rgb(223, 224, 217);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    二目鱼
                </h3>
                <div class="color__hex">#DFE0D9</div>
                <div class="color__rgb">RGB(223, 224, 217)</div>
                <div class="color__cmyk">CMYK(15,10,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D4D3CA"
                data-cmyk-text="CMYK(20,15,20,0)"
                style="background-color: rgb(212, 211, 202);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    明月珰
                </h3>
                <div class="color__hex">#D4D3CA</div>
                <div class="color__rgb">RGB(212, 211, 202)</div>
                <div class="color__cmyk">CMYK(20,15,20,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Lesser-Heat">
        <h2>小暑</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#F5B087"
                data-cmyk-text="CMYK(0,40,45,0)"
                style="background-color: rgb(245, 176, 135);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    骍刚
                </h3>
                <div class="color__hex">#F5B087</div>
                <div class="color__rgb">RGB(245, 176, 135)</div>
                <div class="color__cmyk">CMYK(0,40,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F18F60"
                data-cmyk-text="CMYK(0,55,60,0)"
                style="background-color: rgb(241, 143, 96);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赪霞
                </h3>
                <div class="color__hex">#F18F60</div>
                <div class="color__rgb">RGB(241, 143, 96)</div>
                <div class="color__cmyk">CMYK(0,55,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EF845D"
                data-cmyk-text="CMYK(0,60,60,0)"
                style="background-color: rgb(239, 132, 93);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赪尾
                </h3>
                <div class="color__hex">#EF845D</div>
                <div class="color__rgb">RGB(239, 132, 93)</div>
                <div class="color__cmyk">CMYK(0,60,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ED6D46"
                data-cmyk-text="CMYK(0,70,70,0)"
                style="background-color: rgb(237, 109, 70);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱柿
                </h3>
                <div class="color__hex">#ED6D46</div>
                <div class="color__rgb">RGB(237, 109, 70)</div>
                <div class="color__cmyk">CMYK(0,70,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E0DFC6"
                data-cmyk-text="CMYK(15,10,25,0)"
                style="background-color: rgb(224, 223, 198);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    天球
                </h3>
                <div class="color__hex">#E0DFC6</div>
                <div class="color__rgb">RGB(224, 223, 198)</div>
                <div class="color__cmyk">CMYK(15,10,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BFB99C"
                data-cmyk-text="CMYK(30,25,40,0)"
                style="background-color: rgb(191, 185, 156);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    行香子
                </h3>
                <div class="color__hex">#BFB99C</div>
                <div class="color__rgb">RGB(191, 185, 156)</div>
                <div class="color__cmyk">CMYK(30,25,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A99F70"
                data-cmyk-text="CMYK(40,35,60,0)"
                style="background-color: rgb(169, 159, 112);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    王刍
                </h3>
                <div class="color__hex">#A99F70</div>
                <div class="color__rgb">RGB(169, 159, 112)</div>
                <div class="color__cmyk">CMYK(40,35,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#877D52"
                data-cmyk-text="CMYK(55,50,75,0)"
                style="background-color: rgb(135, 125, 82);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    荩箧
                </h3>
                <div class="color__hex">#877D52</div>
                <div class="color__rgb">RGB(135, 125, 82)</div>
                <div class="color__cmyk">CMYK(55,50,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#954024"
                data-cmyk-text="CMYK(45,85,100,10)"
                style="background-color: rgb(149, 64, 36);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赤灵
                </h3>
                <div class="color__hex">#954024</div>
                <div class="color__rgb">RGB(149, 64, 36)</div>
                <div class="color__cmyk">CMYK(45,85,100,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#873424"
                data-cmyk-text="CMYK(50,90,100,15)"
                style="background-color: rgb(135, 52, 36);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    丹秫
                </h3>
                <div class="color__hex">#873424</div>
                <div class="color__rgb">RGB(135, 52, 36)</div>
                <div class="color__cmyk">CMYK(50,90,100,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#662B1F"
                data-cmyk-text="CMYK(60,90,100,30)"
                style="background-color: rgb(102, 43, 31);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    木兰
                </h3>
                <div class="color__hex">#662B1F</div>
                <div class="color__rgb">RGB(102, 43, 31)</div>
                <div class="color__cmyk">CMYK(60,90,100,30)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4C1E1A"
                data-cmyk-text="CMYK(70,95,100,40)"
                style="background-color: rgb(76, 30, 26);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    麒麟竭
                </h3>
                <div class="color__hex">#4C1E1A</div>
                <div class="color__rgb">RGB(76, 30, 26)</div>
                <div class="color__cmyk">CMYK(70,95,100,40)</div>
            </div>

            <div
                class="color"
                data-hex-text="#106898"
                data-cmyk-text="CMYK(85,50,20,10)"
                style="background-color: rgb(16, 104, 152);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    柔蓝
                </h3>
                <div class="color__hex">#106898</div>
                <div class="color__rgb">RGB(16, 104, 152)</div>
                <div class="color__cmyk">CMYK(85,50,20,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#12507B"
                data-cmyk-text="CMYK(90,65,30,15)"
                style="background-color: rgb(18, 80, 123);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    碧城
                </h3>
                <div class="color__hex">#12507B</div>
                <div class="color__rgb">RGB(18, 80, 123)</div>
                <div class="color__cmyk">CMYK(90,65,30,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#06436F"
                data-cmyk-text="CMYK(95,75,35,15)"
                style="background-color: rgb(6, 67, 111);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蓝采和
                </h3>
                <div class="color__hex">#06436F</div>
                <div class="color__rgb">RGB(6, 67, 111)</div>
                <div class="color__cmyk">CMYK(95,75,35,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#003460"
                data-cmyk-text="CMYK(100,85,40,20)"
                style="background-color: rgb(0, 52, 96);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    帝释青
                </h3>
                <div class="color__hex">#003460</div>
                <div class="color__rgb">RGB(0, 52, 96)</div>
                <div class="color__cmyk">CMYK(100,85,40,20)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Greater-Heat">
        <h2>大暑</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#E3ADB9"
                data-cmyk-text="CMYK(10,40,15,0)"
                style="background-color: rgb(227, 173, 185);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    夕岚
                </h3>
                <div class="color__hex">#E3ADB9</div>
                <div class="color__rgb">RGB(227, 173, 185)</div>
                <div class="color__cmyk">CMYK(10,40,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CF929E"
                data-cmyk-text="CMYK(20,50,25,0)"
                style="background-color: rgb(207, 146, 158);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    雌霓
                </h3>
                <div class="color__hex">#CF929E</div>
                <div class="color__rgb">RGB(207, 146, 158)</div>
                <div class="color__cmyk">CMYK(20,50,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B27777"
                data-cmyk-text="CMYK(35,60,45,0)"
                style="background-color: rgb(178, 119, 119);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绛纱
                </h3>
                <div class="color__hex">#B27777</div>
                <div class="color__rgb">RGB(178, 119, 119)</div>
                <div class="color__cmyk">CMYK(35,60,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A35F65"
                data-cmyk-text="CMYK(40,70,50,5)"
                style="background-color: rgb(163, 95, 101);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    茹藘
                </h3>
                <div class="color__hex">#A35F65</div>
                <div class="color__rgb">RGB(163, 95, 101)</div>
                <div class="color__cmyk">CMYK(40,70,50,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EDF1BB"
                data-cmyk-text="CMYK(10,0,35,0)"
                style="background-color: rgb(237, 241, 187);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    葱青
                </h3>
                <div class="color__hex">#EDF1BB</div>
                <div class="color__rgb">RGB(237, 241, 187)</div>
                <div class="color__cmyk">CMYK(10,0,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E3EB98"
                data-cmyk-text="CMYK(15,0,50,0)"
                style="background-color: rgb(227, 235, 152);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    少艾
                </h3>
                <div class="color__hex">#E3EB98</div>
                <div class="color__rgb">RGB(227, 235, 152)</div>
                <div class="color__cmyk">CMYK(15,0,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D8DE8A"
                data-cmyk-text="CMYK(20,5,55,0)"
                style="background-color: rgb(216, 222, 138);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绮钱
                </h3>
                <div class="color__hex">#D8DE8A</div>
                <div class="color__rgb">RGB(216, 222, 138)</div>
                <div class="color__cmyk">CMYK(20,5,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CDD171"
                data-cmyk-text="CMYK(25,10,65,0)"
                style="background-color: rgb(205, 209, 113);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    翠樽
                </h3>
                <div class="color__hex">#CDD171</div>
                <div class="color__rgb">RGB(205, 209, 113)</div>
                <div class="color__cmyk">CMYK(25,10,65,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D4BF89"
                data-cmyk-text="CMYK(20,25,50,0)"
                style="background-color: rgb(212, 191, 137);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石蜜
                </h3>
                <div class="color__hex">#D4BF89</div>
                <div class="color__rgb">RGB(212, 191, 137)</div>
                <div class="color__cmyk">CMYK(20,25,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BFA670"
                data-cmyk-text="CMYK(30,35,60,0)"
                style="background-color: rgb(191, 166, 112);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    沙饧
                </h3>
                <div class="color__hex">#BFA670</div>
                <div class="color__rgb">RGB(191, 166, 112)</div>
                <div class="color__cmyk">CMYK(30,35,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#AA8E59"
                data-cmyk-text="CMYK(40,45,70,0)"
                style="background-color: rgb(170, 142, 89);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    巨吕
                </h3>
                <div class="color__hex">#AA8E59</div>
                <div class="color__rgb">RGB(170, 142, 89)</div>
                <div class="color__cmyk">CMYK(40,45,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#896D47"
                data-cmyk-text="CMYK(55,60,80,0)"
                style="background-color: rgb(137, 109, 71);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    吉金
                </h3>
                <div class="color__hex">#896D47</div>
                <div class="color__rgb">RGB(137, 109, 71)</div>
                <div class="color__cmyk">CMYK(55,60,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BED2BB"
                data-cmyk-text="CMYK(30,10,30,0)"
                style="background-color: rgb(190, 210, 187);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    山岚
                </h3>
                <div class="color__hex">#BED2BB</div>
                <div class="color__rgb">RGB(190, 210, 187)</div>
                <div class="color__cmyk">CMYK(30,10,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9BB496"
                data-cmyk-text="CMYK(45,20,45,0)"
                style="background-color: rgb(155, 180, 150);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    渌波
                </h3>
                <div class="color__hex">#9BB496</div>
                <div class="color__rgb">RGB(155, 180, 150)</div>
                <div class="color__cmyk">CMYK(45,20,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#81A380"
                data-cmyk-text="CMYK(55,25,55,0)"
                style="background-color: rgb(129, 163, 128);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青楸
                </h3>
                <div class="color__hex">#81A380</div>
                <div class="color__rgb">RGB(129, 163, 128)</div>
                <div class="color__cmyk">CMYK(55,25,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#698E6A"
                data-cmyk-text="CMYK(65,35,65,0)"
                style="background-color: rgb(105, 142, 106);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    菉竹
                </h3>
                <div class="color__hex">#698E6A</div>
                <div class="color__rgb">RGB(105, 142, 106)</div>
                <div class="color__cmyk">CMYK(65,35,65,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Beginning-of-Autumn">
        <h2>立秋</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#88ABDA"
                data-cmyk-text="CMYK(50,25,0,0)"
                style="background-color: rgb(136, 171, 218);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    窃蓝
                </h3>
                <div class="color__hex">#88ABDA</div>
                <div class="color__rgb">RGB(136, 171, 218)</div>
                <div class="color__cmyk">CMYK(50,25,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6F94CD"
                data-cmyk-text="CMYK(60,35,0,0)"
                style="background-color: rgb(111, 148, 205);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    监德
                </h3>
                <div class="color__hex">#6F94CD</div>
                <div class="color__rgb">RGB(111, 148, 205)</div>
                <div class="color__cmyk">CMYK(60,35,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5976BA"
                data-cmyk-text="CMYK(70,50,0,0)"
                style="background-color: rgb(89, 118, 186);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苍苍
                </h3>
                <div class="color__hex">#5976BA</div>
                <div class="color__rgb">RGB(89, 118, 186)</div>
                <div class="color__cmyk">CMYK(70,50,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#2E59A7"
                data-cmyk-text="CMYK(85,65,0,0)"
                style="background-color: rgb(46, 89, 167);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    群青
                </h3>
                <div class="color__hex">#2E59A7</div>
                <div class="color__rgb">RGB(46, 89, 167)</div>
                <div class="color__cmyk">CMYK(85,65,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#98B6C2"
                data-cmyk-text="CMYK(45,20,20,0)"
                style="background-color: rgb(152, 182, 194);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    白青
                </h3>
                <div class="color__hex">#98B6C2</div>
                <div class="color__rgb">RGB(152, 182, 194)</div>
                <div class="color__cmyk">CMYK(45,20,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7F9FAF"
                data-cmyk-text="CMYK(55,30,25,0)"
                style="background-color: rgb(127, 159, 175);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    竹月
                </h3>
                <div class="color__hex">#7F9FAF</div>
                <div class="color__rgb">RGB(127, 159, 175)</div>
                <div class="color__cmyk">CMYK(55,30,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#66889E"
                data-cmyk-text="CMYK(65,40,30,0)"
                style="background-color: rgb(102, 136, 158);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    空青
                </h3>
                <div class="color__hex">#66889E</div>
                <div class="color__rgb">RGB(102, 136, 158)</div>
                <div class="color__cmyk">CMYK(65,40,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#547689"
                data-cmyk-text="CMYK(70,45,35,10)"
                style="background-color: rgb(84, 118, 137);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    太师青
                </h3>
                <div class="color__hex">#547689</div>
                <div class="color__rgb">RGB(84, 118, 137)</div>
                <div class="color__cmyk">CMYK(70,45,35,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EFEFEF"
                data-cmyk-text="CMYK(0,0,0,10)"
                style="background-color: rgb(239, 239, 239);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    缟羽
                </h3>
                <div class="color__hex">#EFEFEF</div>
                <div class="color__rgb">RGB(239, 239, 239)</div>
                <div class="color__cmyk">CMYK(0,0,0,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D8D1C5"
                data-cmyk-text="CMYK(15,15,20,5)"
                style="background-color: rgb(216, 209, 197);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    香皮
                </h3>
                <div class="color__hex">#D8D1C5</div>
                <div class="color__rgb">RGB(216, 209, 197)</div>
                <div class="color__cmyk">CMYK(15,15,20,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C6BEB1"
                data-cmyk-text="CMYK(20,20,25,10)"
                style="background-color: rgb(198, 190, 177);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    云母
                </h3>
                <div class="color__hex">#C6BEB1</div>
                <div class="color__rgb">RGB(198, 190, 177)</div>
                <div class="color__cmyk">CMYK(20,20,25,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#AC9F8A"
                data-cmyk-text="CMYK(30,30,40,15)"
                style="background-color: rgb(172, 159, 138);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    佩玖
                </h3>
                <div class="color__hex">#AC9F8A</div>
                <div class="color__rgb">RGB(172, 159, 138)</div>
                <div class="color__cmyk">CMYK(30,30,40,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C0D09D"
                data-cmyk-text="CMYK(30,10,45,0)"
                style="background-color: rgb(192, 208, 157);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    麹尘
                </h3>
                <div class="color__hex">#C0D09D</div>
                <div class="color__rgb">RGB(192, 208, 157)</div>
                <div class="color__cmyk">CMYK(30,10,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#938F4C"
                data-cmyk-text="CMYK(50,40,80,0)"
                style="background-color: rgb(147, 143, 76);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绿沈
                </h3>
                <div class="color__hex">#938F4C</div>
                <div class="color__rgb">RGB(147, 143, 76)</div>
                <div class="color__cmyk">CMYK(50,40,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7F754C"
                data-cmyk-text="CMYK(55,50,75,10)"
                style="background-color: rgb(127, 117, 76);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绞衣
                </h3>
                <div class="color__hex">#7F754C</div>
                <div class="color__rgb">RGB(127, 117, 76)</div>
                <div class="color__cmyk">CMYK(55,50,75,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#595333"
                data-cmyk-text="CMYK(70,65,90,20)"
                style="background-color: rgb(89, 83, 51);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    素綦
                </h3>
                <div class="color__hex">#595333</div>
                <div class="color__rgb">RGB(89, 83, 51)</div>
                <div class="color__cmyk">CMYK(70,65,90,20)</div>
            </div>
        </div>
    </div>
    <div class="solar_term End-of-Heat">
        <h2>处暑</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#F0CFE3"
                data-cmyk-text="CMYK(5,25,0,0)"
                style="background-color: rgb(240, 207, 227);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    退红
                </h3>
                <div class="color__hex">#F0CFE3</div>
                <div class="color__rgb">RGB(240, 207, 227)</div>
                <div class="color__cmyk">CMYK(5,25,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E4B8D5"
                data-cmyk-text="CMYK(10,35,0,0)"
                style="background-color: rgb(228, 184, 213);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    樱花
                </h3>
                <div class="color__hex">#E4B8D5</div>
                <div class="color__rgb">RGB(228, 184, 213)</div>
                <div class="color__cmyk">CMYK(10,35,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CE93BF"
                data-cmyk-text="CMYK(20,50,0,0)"
                style="background-color: rgb(206, 147, 191);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    丁香
                </h3>
                <div class="color__hex">#CE93BF</div>
                <div class="color__rgb">RGB(206, 147, 191)</div>
                <div class="color__cmyk">CMYK(20,50,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BA79B1"
                data-cmyk-text="CMYK(30,60,0,0)"
                style="background-color: rgb(186, 121, 177);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    木槿
                </h3>
                <div class="color__hex">#BA79B1</div>
                <div class="color__rgb">RGB(186, 121, 177)</div>
                <div class="color__cmyk">CMYK(30,60,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C9CFC1"
                data-cmyk-text="CMYK(25,15,25,0)"
                style="background-color: rgb(201, 207, 193);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    余白
                </h3>
                <div class="color__hex">#C9CFC1</div>
                <div class="color__rgb">RGB(201, 207, 193)</div>
                <div class="color__cmyk">CMYK(25,15,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A8B78C"
                data-cmyk-text="CMYK(40,20,50,0)"
                style="background-color: rgb(168, 183, 140);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    兰苕
                </h3>
                <div class="color__hex">#A8B78C</div>
                <div class="color__rgb">RGB(168, 183, 140)</div>
                <div class="color__cmyk">CMYK(40,20,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#90A07D"
                data-cmyk-text="CMYK(50,30,55,0)"
                style="background-color: rgb(144, 160, 125);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    碧滋
                </h3>
                <div class="color__hex">#90A07D</div>
                <div class="color__rgb">RGB(144, 160, 125)</div>
                <div class="color__cmyk">CMYK(50,30,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6C8650"
                data-cmyk-text="CMYK(65,40,80,0)"
                style="background-color: rgb(108, 134, 80);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    葱倩
                </h3>
                <div class="color__hex">#6C8650</div>
                <div class="color__rgb">RGB(108, 134, 80)</div>
                <div class="color__cmyk">CMYK(65,40,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A2D2E2"
                data-cmyk-text="CMYK(40,5,10,0)"
                style="background-color: rgb(162, 210, 226);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    云门
                </h3>
                <div class="color__hex">#A2D2E2</div>
                <div class="color__rgb">RGB(162, 210, 226)</div>
                <div class="color__cmyk">CMYK(40,5,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#87C0CA"
                data-cmyk-text="CMYK(50,10,20,0)"
                style="background-color: rgb(135, 192, 202);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    西子
                </h3>
                <div class="color__hex">#87C0CA</div>
                <div class="color__rgb">RGB(135, 192, 202)</div>
                <div class="color__cmyk">CMYK(50,10,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5AA4AE"
                data-cmyk-text="CMYK(65,20,30,0)"
                style="background-color: rgb(90, 164, 174);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    天水碧
                </h3>
                <div class="color__hex">#5AA4AE</div>
                <div class="color__rgb">RGB(90, 164, 174)</div>
                <div class="color__cmyk">CMYK(65,20,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#108B96"
                data-cmyk-text="CMYK(80,30,40,0)"
                style="background-color: rgb(16, 139, 150);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    法翠
                </h3>
                <div class="color__hex">#108B96</div>
                <div class="color__rgb">RGB(16, 139, 150)</div>
                <div class="color__cmyk">CMYK(80,30,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EAD89A"
                data-cmyk-text="CMYK(10,15,45,0)"
                style="background-color: rgb(234, 216, 154);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    桑蕾
                </h3>
                <div class="color__hex">#EAD89A</div>
                <div class="color__rgb">RGB(234, 216, 154)</div>
                <div class="color__cmyk">CMYK(10,15,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D5B45C"
                data-cmyk-text="CMYK(20,30,70,0)"
                style="background-color: rgb(213, 180, 92);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    太一余粮
                </h3>
                <div class="color__hex">#D5B45C</div>
                <div class="color__rgb">RGB(213, 180, 92)</div>
                <div class="color__cmyk">CMYK(20,30,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BF9C46"
                data-cmyk-text="CMYK(30,40,80,0)"
                style="background-color: rgb(191, 156, 70);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    秋香
                </h3>
                <div class="color__hex">#BF9C46</div>
                <div class="color__rgb">RGB(191, 156, 70)</div>
                <div class="color__cmyk">CMYK(30,40,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#AA8534"
                data-cmyk-text="CMYK(40,50,90,0)"
                style="background-color: rgb(170, 133, 52);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    老茯神
                </h3>
                <div class="color__hex">#AA8534</div>
                <div class="color__rgb">RGB(170, 133, 52)</div>
                <div class="color__cmyk">CMYK(40,50,90,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term White-Dew">
        <h2>白露</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#F5F2E9"
                data-cmyk-text="CMYK(5,5,10,0)"
                style="background-color: rgb(245, 242, 233);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    凝脂
                </h3>
                <div class="color__hex">#F5F2E9</div>
                <div class="color__rgb">RGB(245, 242, 233)</div>
                <div class="color__cmyk">CMYK(5,5,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EAE4D1"
                data-cmyk-text="CMYK(10,10,20,0)"
                style="background-color: rgb(234, 228, 209);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    玉色
                </h3>
                <div class="color__hex">#EAE4D1</div>
                <div class="color__rgb">RGB(234, 228, 209)</div>
                <div class="color__cmyk">CMYK(10,10,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DFD6B8"
                data-cmyk-text="CMYK(15,15,30,0)"
                style="background-color: rgb(223, 214, 184);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄润
                </h3>
                <div class="color__hex">#DFD6B8</div>
                <div class="color__rgb">RGB(223, 214, 184)</div>
                <div class="color__cmyk">CMYK(15,15,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D5C8A0"
                data-cmyk-text="CMYK(20,20,40,0)"
                style="background-color: rgb(213, 200, 160);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    缣缃
                </h3>
                <div class="color__hex">#D5C8A0</div>
                <div class="color__rgb">RGB(213, 200, 160)</div>
                <div class="color__cmyk">CMYK(20,20,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#86908A"
                data-cmyk-text="CMYK(50,35,40,10)"
                style="background-color: rgb(134, 144, 138);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蕉月
                </h3>
                <div class="color__hex">#86908A</div>
                <div class="color__rgb">RGB(134, 144, 138)</div>
                <div class="color__cmyk">CMYK(50,35,40,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6B7D73"
                data-cmyk-text="CMYK(60,40,50,15)"
                style="background-color: rgb(107, 125, 115);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    千山翠
                </h3>
                <div class="color__hex">#6B7D73</div>
                <div class="color__rgb">RGB(107, 125, 115)</div>
                <div class="color__cmyk">CMYK(60,40,50,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#555F4D"
                data-cmyk-text="CMYK(70,55,70,20)"
                style="background-color: rgb(85, 95, 77);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    结绿
                </h3>
                <div class="color__hex">#555F4D</div>
                <div class="color__rgb">RGB(85, 95, 77)</div>
                <div class="color__cmyk">CMYK(70,55,70,20)</div>
            </div>

            <div
                class="color"
                data-hex-text="#45493D"
                data-cmyk-text="CMYK(75,65,75,30)"
                style="background-color: rgb(69, 73, 61);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绿云
                </h3>
                <div class="color__hex">#45493D</div>
                <div class="color__rgb">RGB(69, 73, 61)</div>
                <div class="color__cmyk">CMYK(75,65,75,30)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D3CBC5"
                data-cmyk-text="CMYK(20,20,20,0)"
                style="background-color: rgb(211, 203, 197);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    藕丝秋半
                </h3>
                <div class="color__hex">#D3CBC5</div>
                <div class="color__rgb">RGB(211, 203, 197)</div>
                <div class="color__cmyk">CMYK(20,20,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C8B5B3"
                data-cmyk-text="CMYK(25,30,25,0)"
                style="background-color: rgb(200, 181, 179);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苍烟落照
                </h3>
                <div class="color__hex">#C8B5B3</div>
                <div class="color__rgb">RGB(200, 181, 179)</div>
                <div class="color__cmyk">CMYK(25,30,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#928187"
                data-cmyk-text="CMYK(50,50,40,0)"
                style="background-color: rgb(146, 129, 135);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    红藤杖
                </h3>
                <div class="color__hex">#928187</div>
                <div class="color__rgb">RGB(146, 129, 135)</div>
                <div class="color__cmyk">CMYK(50,50,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#594C57"
                data-cmyk-text="CMYK(65,65,50,30)"
                style="background-color: rgb(89, 76, 87);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫鼠
                </h3>
                <div class="color__hex">#594C57</div>
                <div class="color__rgb">RGB(89, 76, 87)</div>
                <div class="color__cmyk">CMYK(65,65,50,30)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C4B798"
                data-cmyk-text="CMYK(25,25,40,5)"
                style="background-color: rgb(196, 183, 152);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄粱
                </h3>
                <div class="color__hex">#C4B798</div>
                <div class="color__rgb">RGB(196, 183, 152)</div>
                <div class="color__cmyk">CMYK(25,25,40,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A58A5F"
                data-cmyk-text="CMYK(40,45,65,5)"
                style="background-color: rgb(165, 138, 95);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蒸栗
                </h3>
                <div class="color__hex">#A58A5F</div>
                <div class="color__rgb">RGB(165, 138, 95)</div>
                <div class="color__cmyk">CMYK(40,45,65,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7C623F"
                data-cmyk-text="CMYK(55,60,80,15)"
                style="background-color: rgb(124, 98, 63);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    射干
                </h3>
                <div class="color__hex">#7C623F</div>
                <div class="color__rgb">RGB(124, 98, 63)</div>
                <div class="color__cmyk">CMYK(55,60,80,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#644D31"
                data-cmyk-text="CMYK(65,70,90,20)"
                style="background-color: rgb(100, 77, 49);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    油葫芦
                </h3>
                <div class="color__hex">#644D31</div>
                <div class="color__rgb">RGB(100, 77, 49)</div>
                <div class="color__cmyk">CMYK(65,70,90,20)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Autumnal-Equinox">
        <h2>秋分</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#D5E3D4"
                data-cmyk-text="CMYK(20,5,20,0)"
                style="background-color: rgb(213, 227, 212);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    卵色
                </h3>
                <div class="color__hex">#D5E3D4</div>
                <div class="color__rgb">RGB(213, 227, 212)</div>
                <div class="color__cmyk">CMYK(20,5,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CAD7C5"
                data-cmyk-text="CMYK(25,10,25,0)"
                style="background-color: rgb(202, 215, 197);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    葭菼
                </h3>
                <div class="color__hex">#CAD7C5</div>
                <div class="color__rgb">RGB(202, 215, 197)</div>
                <div class="color__cmyk">CMYK(25,10,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BECAB7"
                data-cmyk-text="CMYK(30,15,30,0)"
                style="background-color: rgb(190, 202, 183);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    冰台
                </h3>
                <div class="color__hex">#BECAB7</div>
                <div class="color__rgb">RGB(190, 202, 183)</div>
                <div class="color__cmyk">CMYK(30,15,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B3BDA9"
                data-cmyk-text="CMYK(35,20,35,0)"
                style="background-color: rgb(179, 189, 169);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青古
                </h3>
                <div class="color__hex">#B3BDA9</div>
                <div class="color__rgb">RGB(179, 189, 169)</div>
                <div class="color__cmyk">CMYK(35,20,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C0AD5E"
                data-cmyk-text="CMYK(30,30,70,0)"
                style="background-color: rgb(192, 173, 94);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    栾华
                </h3>
                <div class="color__hex">#C0AD5E</div>
                <div class="color__rgb">RGB(192, 173, 94)</div>
                <div class="color__cmyk">CMYK(30,30,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#AA9649"
                data-cmyk-text="CMYK(40,40,80,0)"
                style="background-color: rgb(170, 150, 73);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    大赤
                </h3>
                <div class="color__hex">#AA9649</div>
                <div class="color__rgb">RGB(170, 150, 73)</div>
                <div class="color__cmyk">CMYK(40,40,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8F3D2C"
                data-cmyk-text="CMYK(45,85,90,15)"
                style="background-color: rgb(143, 61, 44);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    佛赤
                </h3>
                <div class="color__hex">#8F3D2C</div>
                <div class="color__rgb">RGB(143, 61, 44)</div>
                <div class="color__cmyk">CMYK(45,85,90,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#683632"
                data-cmyk-text="CMYK(55,80,75,35)"
                style="background-color: rgb(104, 54, 50);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蜜褐
                </h3>
                <div class="color__hex">#683632</div>
                <div class="color__rgb">RGB(104, 54, 50)</div>
                <div class="color__cmyk">CMYK(55,80,75,35)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4994C4"
                data-cmyk-text="CMYK(70,30,10,0)"
                style="background-color: rgb(73, 148, 196);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    孔雀蓝
                </h3>
                <div class="color__hex">#4994C4</div>
                <div class="color__rgb">RGB(73, 148, 196)</div>
                <div class="color__cmyk">CMYK(70,30,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4182A4"
                data-cmyk-text="CMYK(75,40,25,0)"
                style="background-color: rgb(65, 130, 164);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    吐绶蓝
                </h3>
                <div class="color__hex">#4182A4</div>
                <div class="color__rgb">RGB(65, 130, 164)</div>
                <div class="color__cmyk">CMYK(75,40,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#32788A"
                data-cmyk-text="CMYK(80,45,40,0)"
                style="background-color: rgb(50, 120, 138);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鱼师青
                </h3>
                <div class="color__hex">#32788A</div>
                <div class="color__rgb">RGB(50, 120, 138)</div>
                <div class="color__cmyk">CMYK(80,45,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#006D87"
                data-cmyk-text="CMYK(90,50,40,0)"
                style="background-color: rgb(0, 109, 135);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    软翠
                </h3>
                <div class="color__hex">#006D87</div>
                <div class="color__rgb">RGB(0, 109, 135)</div>
                <div class="color__cmyk">CMYK(90,50,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EAEEF1"
                data-cmyk-text="CMYK(10,5,5,0)"
                style="background-color: rgb(234, 238, 241);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    浅云
                </h3>
                <div class="color__hex">#EAEEF1</div>
                <div class="color__rgb">RGB(234, 238, 241)</div>
                <div class="color__cmyk">CMYK(10,5,5,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D4DDE1"
                data-cmyk-text="CMYK(20,10,10,0)"
                style="background-color: rgb(212, 221, 225);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    素采
                </h3>
                <div class="color__hex">#D4DDE1</div>
                <div class="color__rgb">RGB(212, 221, 225)</div>
                <div class="color__cmyk">CMYK(20,10,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BDCBD2"
                data-cmyk-text="CMYK(30,15,15,0)"
                style="background-color: rgb(189, 203, 210);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    影青
                </h3>
                <div class="color__hex">#BDCBD2</div>
                <div class="color__rgb">RGB(189, 203, 210)</div>
                <div class="color__cmyk">CMYK(30,15,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B2BFC3"
                data-cmyk-text="CMYK(35,20,20,0)"
                style="background-color: rgb(178, 191, 195);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    逍遥游
                </h3>
                <div class="color__hex">#B2BFC3</div>
                <div class="color__rgb">RGB(178, 191, 195)</div>
                <div class="color__cmyk">CMYK(35,20,20,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Cold-Dew">
        <h2>寒露</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#A6BAB1"
                data-cmyk-text="CMYK(40,20,30,0)"
                style="background-color: rgb(166, 186, 177);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    醽醁
                </h3>
                <div class="color__hex">#A6BAB1</div>
                <div class="color__rgb">RGB(166, 186, 177)</div>
                <div class="color__cmyk">CMYK(40,20,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#819D8E"
                data-cmyk-text="CMYK(55,30,45,0)"
                style="background-color: rgb(129, 157, 142);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    翠涛
                </h3>
                <div class="color__hex">#819D8E</div>
                <div class="color__rgb">RGB(129, 157, 142)</div>
                <div class="color__cmyk">CMYK(55,30,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#778A77"
                data-cmyk-text="CMYK(60,40,55,0)"
                style="background-color: rgb(119, 138, 119);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青梅
                </h3>
                <div class="color__hex">#778A77</div>
                <div class="color__rgb">RGB(119, 138, 119)</div>
                <div class="color__cmyk">CMYK(60,40,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5F766A"
                data-cmyk-text="CMYK(70,50,60,0)"
                style="background-color: rgb(95, 118, 106);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    翕赩
                </h3>
                <div class="color__hex">#5F766A</div>
                <div class="color__rgb">RGB(95, 118, 106)</div>
                <div class="color__cmyk">CMYK(70,50,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DDB078"
                data-cmyk-text="CMYK(15,35,55,0)"
                style="background-color: rgb(221, 176, 120);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    九斤黄
                </h3>
                <div class="color__hex">#DDB078</div>
                <div class="color__rgb">RGB(221, 176, 120)</div>
                <div class="color__cmyk">CMYK(15,35,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DA9233"
                data-cmyk-text="CMYK(15,50,85,0)"
                style="background-color: rgb(218, 146, 51);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    杏子
                </h3>
                <div class="color__hex">#DA9233</div>
                <div class="color__rgb">RGB(218, 146, 51)</div>
                <div class="color__cmyk">CMYK(15,50,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BC6E37"
                data-cmyk-text="CMYK(30,65,85,0)"
                style="background-color: rgb(188, 110, 55);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    媚蝶
                </h3>
                <div class="color__hex">#BC6E37</div>
                <div class="color__rgb">RGB(188, 110, 55)</div>
                <div class="color__cmyk">CMYK(30,65,85,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9F5221"
                data-cmyk-text="CMYK(40,75,100,10)"
                style="background-color: rgb(159, 82, 33);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    韎韐
                </h3>
                <div class="color__hex">#9F5221</div>
                <div class="color__rgb">RGB(159, 82, 33)</div>
                <div class="color__cmyk">CMYK(40,75,100,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8BA3C7"
                data-cmyk-text="CMYK(50,30,10,0)"
                style="background-color: rgb(139, 163, 199);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    东方既白
                </h3>
                <div class="color__hex">#8BA3C7</div>
                <div class="color__rgb">RGB(139, 163, 199)</div>
                <div class="color__cmyk">CMYK(50,30,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#003D74"
                data-cmyk-text="CMYK(100,86,35,0)"
                style="background-color: rgb(0, 61, 116);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绀宇
                </h3>
                <div class="color__hex">#003D74</div>
                <div class="color__rgb">RGB(0, 61, 116)</div>
                <div class="color__cmyk">CMYK(100,86,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#19325F"
                data-cmyk-text="CMYK(100,95,50,0)"
                style="background-color: rgb(25, 50, 95);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    佛头青
                </h3>
                <div class="color__hex">#19325F</div>
                <div class="color__rgb">RGB(25, 50, 95)</div>
                <div class="color__cmyk">CMYK(100,95,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#1A2847"
                data-cmyk-text="CMYK(100,100,65,15)"
                style="background-color: rgb(26, 40, 71);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    花青
                </h3>
                <div class="color__hex">#1A2847</div>
                <div class="color__rgb">RGB(26, 40, 71)</div>
                <div class="color__cmyk">CMYK(100,100,65,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ECD9C7"
                data-cmyk-text="CMYK(5,15,20,5)"
                style="background-color: rgb(236, 217, 199);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    弗肯红
                </h3>
                <div class="color__hex">#ECD9C7</div>
                <div class="color__rgb">RGB(236, 217, 199)</div>
                <div class="color__cmyk">CMYK(5,15,20,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E1C199"
                data-cmyk-text="CMYK(10,25,40,5)"
                style="background-color: rgb(225, 193, 153);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    赤璋
                </h3>
                <div class="color__hex">#E1C199</div>
                <div class="color__rgb">RGB(225, 193, 153)</div>
                <div class="color__cmyk">CMYK(10,25,40,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C6A268"
                data-cmyk-text="CMYK(20,35,60,10)"
                style="background-color: rgb(198, 162, 104);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    茧色
                </h3>
                <div class="color__hex">#C6A268</div>
                <div class="color__rgb">RGB(198, 162, 104)</div>
                <div class="color__cmyk">CMYK(20,35,60,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B3934B"
                data-cmyk-text="CMYK(30,40,75,10)"
                style="background-color: rgb(179, 147, 75);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    密陀僧
                </h3>
                <div class="color__hex">#B3934B</div>
                <div class="color__rgb">RGB(179, 147, 75)</div>
                <div class="color__cmyk">CMYK(30,40,75,10)</div>
            </div>
        </div>
    </div>
    <div class="solar_term First-Frost">
        <h2>霜降</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#D12920"
                data-cmyk-text="CMYK(15,95,95,0)"
                style="background-color: rgb(209, 41, 32);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    银朱
                </h3>
                <div class="color__hex">#D12920</div>
                <div class="color__rgb">RGB(209, 41, 32)</div>
                <div class="color__cmyk">CMYK(15,95,95,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#AB1D22"
                data-cmyk-text="CMYK(35,100,100,5)"
                style="background-color: rgb(171, 29, 34);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    胭脂虫
                </h3>
                <div class="color__hex">#AB1D22</div>
                <div class="color__rgb">RGB(171, 29, 34)</div>
                <div class="color__cmyk">CMYK(35,100,100,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8F1D22"
                data-cmyk-text="CMYK(45,100,100,15)"
                style="background-color: rgb(143, 29, 34);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱樱
                </h3>
                <div class="color__hex">#8F1D22</div>
                <div class="color__rgb">RGB(143, 29, 34)</div>
                <div class="color__cmyk">CMYK(45,100,100,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#631216"
                data-cmyk-text="CMYK(55,100,100,40)"
                style="background-color: rgb(99, 18, 22);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    爵头
                </h3>
                <div class="color__hex">#631216</div>
                <div class="color__rgb">RGB(99, 18, 22)</div>
                <div class="color__cmyk">CMYK(55,100,100,40)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BDB2B2"
                data-cmyk-text="CMYK(30,30,25,0)"
                style="background-color: rgb(189, 178, 178);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    甘石
                </h3>
                <div class="color__hex">#BDB2B2</div>
                <div class="color__rgb">RGB(189, 178, 178)</div>
                <div class="color__cmyk">CMYK(30,30,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#91828F"
                data-cmyk-text="CMYK(50,50,35,0)"
                style="background-color: rgb(145, 130, 143);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    迷楼灰
                </h3>
                <div class="color__hex">#91828F</div>
                <div class="color__rgb">RGB(145, 130, 143)</div>
                <div class="color__cmyk">CMYK(50,50,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6A5B6D"
                data-cmyk-text="CMYK(65,65,45,10)"
                style="background-color: rgb(106, 91, 109);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鸦雏
                </h3>
                <div class="color__hex">#6A5B6D</div>
                <div class="color__rgb">RGB(106, 91, 109)</div>
                <div class="color__cmyk">CMYK(65,65,45,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5C4F55"
                data-cmyk-text="CMYK(70,70,60,15)"
                style="background-color: rgb(92, 79, 85);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    烟墨
                </h3>
                <div class="color__hex">#5C4F55</div>
                <div class="color__rgb">RGB(92, 79, 85)</div>
                <div class="color__cmyk">CMYK(70,70,60,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F8C6B5"
                data-cmyk-text="CMYK(0,30,25,0)"
                style="background-color: rgb(248, 198, 181);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    十样锦
                </h3>
                <div class="color__hex">#F8C6B5</div>
                <div class="color__rgb">RGB(248, 198, 181)</div>
                <div class="color__cmyk">CMYK(0,30,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DA9E8C"
                data-cmyk-text="CMYK(15,45,40,0)"
                style="background-color: rgb(218, 158, 140);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    檀唇
                </h3>
                <div class="color__hex">#DA9E8C</div>
                <div class="color__rgb">RGB(218, 158, 140)</div>
                <div class="color__cmyk">CMYK(15,45,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D77F66"
                data-cmyk-text="CMYK(15,60,55,0)"
                style="background-color: rgb(215, 127, 102);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    琼琚
                </h3>
                <div class="color__hex">#D77F66</div>
                <div class="color__rgb">RGB(215, 127, 102)</div>
                <div class="color__cmyk">CMYK(15,60,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B15A43"
                data-cmyk-text="CMYK(35,75,75,0)"
                style="background-color: rgb(177, 90, 67);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    棠梨
                </h3>
                <div class="color__hex">#B15A43</div>
                <div class="color__rgb">RGB(177, 90, 67)</div>
                <div class="color__cmyk">CMYK(35,75,75,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DFD7C2"
                data-cmyk-text="CMYK(15,15,25,0)"
                style="background-color: rgb(223, 215, 194);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蜜合
                </h3>
                <div class="color__hex">#DFD7C2</div>
                <div class="color__rgb">RGB(223, 215, 194)</div>
                <div class="color__cmyk">CMYK(15,15,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D4C1A6"
                data-cmyk-text="CMYK(20,25,35,0)"
                style="background-color: rgb(212, 193, 166);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    假山南
                </h3>
                <div class="color__hex">#D4C1A6</div>
                <div class="color__rgb">RGB(212, 193, 166)</div>
                <div class="color__cmyk">CMYK(20,25,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BEA78B"
                data-cmyk-text="CMYK(30,35,45,0)"
                style="background-color: rgb(190, 167, 139);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫花布
                </h3>
                <div class="color__hex">#BEA78B</div>
                <div class="color__rgb">RGB(190, 167, 139)</div>
                <div class="color__cmyk">CMYK(30,35,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#99806C"
                data-cmyk-text="CMYK(45,50,55,5)"
                style="background-color: rgb(153, 128, 108);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    沉香
                </h3>
                <div class="color__hex">#99806C</div>
                <div class="color__rgb">RGB(153, 128, 108)</div>
                <div class="color__cmyk">CMYK(45,50,55,5)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Beginning-of-Winter">
        <h2>立冬</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#FFFBC7"
                data-cmyk-text="CMYK(0,0,30,0)"
                style="background-color: rgb(255, 251, 199);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    半见
                </h3>
                <div class="color__hex">#FFFBC7</div>
                <div class="color__rgb">RGB(255, 251, 199)</div>
                <div class="color__cmyk">CMYK(0,0,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#F7EEAD"
                data-cmyk-text="CMYK(5,5,40,0)"
                style="background-color: rgb(247, 238, 173);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    女贞黄
                </h3>
                <div class="color__hex">#F7EEAD</div>
                <div class="color__rgb">RGB(247, 238, 173)</div>
                <div class="color__cmyk">CMYK(5,5,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ECE093"
                data-cmyk-text="CMYK(10,10,50,0)"
                style="background-color: rgb(236, 224, 147);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绢纨
                </h3>
                <div class="color__hex">#ECE093</div>
                <div class="color__rgb">RGB(236, 224, 147)</div>
                <div class="color__cmyk">CMYK(10,10,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D6C560"
                data-cmyk-text="CMYK(20,20,70,0)"
                style="background-color: rgb(214, 197, 96);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    姜黄
                </h3>
                <div class="color__hex">#D6C560</div>
                <div class="color__rgb">RGB(214, 197, 96)</div>
                <div class="color__cmyk">CMYK(20,20,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#88BFB8"
                data-cmyk-text="CMYK(50,10,30,0)"
                style="background-color: rgb(136, 191, 184);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    繱犗
                </h3>
                <div class="color__hex">#88BFB8</div>
                <div class="color__rgb">RGB(136, 191, 184)</div>
                <div class="color__cmyk">CMYK(50,10,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5DA39D"
                data-cmyk-text="CMYK(65,20,40,0)"
                style="background-color: rgb(93, 163, 157);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    二绿
                </h3>
                <div class="color__hex">#5DA39D</div>
                <div class="color__rgb">RGB(93, 163, 157)</div>
                <div class="color__cmyk">CMYK(65,20,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#3D8E86"
                data-cmyk-text="CMYK(75,30,50,0)"
                style="background-color: rgb(61, 142, 134);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    铜青
                </h3>
                <div class="color__hex">#3D8E86</div>
                <div class="color__rgb">RGB(61, 142, 134)</div>
                <div class="color__cmyk">CMYK(75,30,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#206864"
                data-cmyk-text="CMYK(85,50,60,10)"
                style="background-color: rgb(32, 104, 100);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石绿
                </h3>
                <div class="color__hex">#206864</div>
                <div class="color__rgb">RGB(32, 104, 100)</div>
                <div class="color__cmyk">CMYK(85,50,60,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9E8C6B"
                data-cmyk-text="CMYK(45,45,60,0)"
                style="background-color: rgb(158, 140, 107);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄琮
                </h3>
                <div class="color__hex">#9E8C6B</div>
                <div class="color__rgb">RGB(158, 140, 107)</div>
                <div class="color__cmyk">CMYK(45,45,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#887657"
                data-cmyk-text="CMYK(55,55,70,0)"
                style="background-color: rgb(136, 118, 87);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    茶色
                </h3>
                <div class="color__hex">#887657</div>
                <div class="color__rgb">RGB(136, 118, 87)</div>
                <div class="color__cmyk">CMYK(55,55,70,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6D5C3D"
                data-cmyk-text="CMYK(60,50,80,20)"
                style="background-color: rgb(109, 92, 61);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    伽罗
                </h3>
                <div class="color__hex">#6D5C3D</div>
                <div class="color__rgb">RGB(109, 92, 61)</div>
                <div class="color__cmyk">CMYK(60,50,80,20)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5A4B3B"
                data-cmyk-text="CMYK(65,65,75,30)"
                style="background-color: rgb(90, 75, 59);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苍艾
                </h3>
                <div class="color__hex">#5A4B3B</div>
                <div class="color__rgb">RGB(90, 75, 59)</div>
                <div class="color__cmyk">CMYK(65,65,75,30)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A88787"
                data-cmyk-text="CMYK(40,50,40,0)"
                style="background-color: rgb(168, 135, 135);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    藕丝褐
                </h3>
                <div class="color__hex">#A88787</div>
                <div class="color__rgb">RGB(168, 135, 135)</div>
                <div class="color__cmyk">CMYK(40,50,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9E696D"
                data-cmyk-text="CMYK(45,65,50,0)"
                style="background-color: rgb(158, 105, 109);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    葡萄褐
                </h3>
                <div class="color__hex">#9E696D</div>
                <div class="color__rgb">RGB(158, 105, 109)</div>
                <div class="color__cmyk">CMYK(45,65,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#81474C"
                data-cmyk-text="CMYK(55,80,65,10)"
                style="background-color: rgb(129, 71, 76);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    苏方
                </h3>
                <div class="color__hex">#81474C</div>
                <div class="color__rgb">RGB(129, 71, 76)</div>
                <div class="color__cmyk">CMYK(55,80,65,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#662B2F"
                data-cmyk-text="CMYK(60,90,80,30)"
                style="background-color: rgb(102, 43, 47);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    福色
                </h3>
                <div class="color__hex">#662B2F</div>
                <div class="color__rgb">RGB(102, 43, 47)</div>
                <div class="color__cmyk">CMYK(60,90,80,30)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Light-Snow">
        <h2>小雪</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#DE82A7"
                data-cmyk-text="CMYK(10,60,10,0)"
                style="background-color: rgb(222, 130, 167);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    龙膏烛
                </h3>
                <div class="color__hex">#DE82A7</div>
                <div class="color__rgb">RGB(222, 130, 167)</div>
                <div class="color__cmyk">CMYK(10,60,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CC73A0"
                data-cmyk-text="CMYK(20,65,10,0)"
                style="background-color: rgb(204, 115, 160);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黪紫
                </h3>
                <div class="color__hex">#CC73A0</div>
                <div class="color__rgb">RGB(204, 115, 160)</div>
                <div class="color__cmyk">CMYK(20,65,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B95A89"
                data-cmyk-text="CMYK(30,75,20,0)"
                style="background-color: rgb(185, 90, 137);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    胭脂水
                </h3>
                <div class="color__hex">#B95A89</div>
                <div class="color__rgb">RGB(185, 90, 137)</div>
                <div class="color__cmyk">CMYK(30,75,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B0436F"
                data-cmyk-text="CMYK(35,85,35,0)"
                style="background-color: rgb(176, 67, 111);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    胭脂紫
                </h3>
                <div class="color__hex">#B0436F</div>
                <div class="color__rgb">RGB(176, 67, 111)</div>
                <div class="color__cmyk">CMYK(35,85,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E67762"
                data-cmyk-text="CMYK(5,65,55,0)"
                style="background-color: rgb(230, 119, 98);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    小红
                </h3>
                <div class="color__hex">#E67762</div>
                <div class="color__rgb">RGB(230, 119, 98)</div>
                <div class="color__cmyk">CMYK(5,65,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DD6B4F"
                data-cmyk-text="CMYK(10,70,65,0)"
                style="background-color: rgb(221, 107, 79);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    岱赭
                </h3>
                <div class="color__hex">#DD6B4F</div>
                <div class="color__rgb">RGB(221, 107, 79)</div>
                <div class="color__cmyk">CMYK(10,70,65,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D24735"
                data-cmyk-text="CMYK(15,85,80,0)"
                style="background-color: rgb(210, 71, 53);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鹤顶红
                </h3>
                <div class="color__hex">#D24735</div>
                <div class="color__rgb">RGB(210, 71, 53)</div>
                <div class="color__cmyk">CMYK(15,85,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B93A26"
                data-cmyk-text="CMYK(30,90,95,0)"
                style="background-color: rgb(185, 58, 38);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱殷
                </h3>
                <div class="color__hex">#B93A26</div>
                <div class="color__rgb">RGB(185, 58, 38)</div>
                <div class="color__cmyk">CMYK(30,90,95,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D4E5EF"
                data-cmyk-text="CMYK(20,5,5,0)"
                style="background-color: rgb(212, 229, 239);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    月白
                </h3>
                <div class="color__hex">#D4E5EF</div>
                <div class="color__rgb">RGB(212, 229, 239)</div>
                <div class="color__cmyk">CMYK(20,5,5,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BCD4E7"
                data-cmyk-text="CMYK(30,10,5,0)"
                style="background-color: rgb(188, 212, 231);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    星郎
                </h3>
                <div class="color__hex">#BCD4E7</div>
                <div class="color__rgb">RGB(188, 212, 231)</div>
                <div class="color__cmyk">CMYK(30,10,5,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A3BBDB"
                data-cmyk-text="CMYK(40,20,5,0)"
                style="background-color: rgb(163, 187, 219);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    晴山
                </h3>
                <div class="color__hex">#A3BBDB</div>
                <div class="color__rgb">RGB(163, 187, 219)</div>
                <div class="color__cmyk">CMYK(40,20,5,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8AABCC"
                data-cmyk-text="CMYK(50,25,10,0)"
                style="background-color: rgb(138, 171, 204);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    品月
                </h3>
                <div class="color__hex">#8AABCC</div>
                <div class="color__rgb">RGB(138, 171, 204)</div>
                <div class="color__cmyk">CMYK(50,25,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9E8368"
                data-cmyk-text="CMYK(45,50,60,0)"
                style="background-color: rgb(158, 131, 104);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    明茶褐
                </h3>
                <div class="color__hex">#9E8368</div>
                <div class="color__rgb">RGB(158, 131, 104)</div>
                <div class="color__cmyk">CMYK(45,50,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#906C4A"
                data-cmyk-text="CMYK(50,60,75,5)"
                style="background-color: rgb(144, 108, 74);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    荆褐
                </h3>
                <div class="color__hex">#906C4A</div>
                <div class="color__rgb">RGB(144, 108, 74)</div>
                <div class="color__cmyk">CMYK(50,60,75,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7C5B3E"
                data-cmyk-text="CMYK(55,65,80,15)"
                style="background-color: rgb(124, 91, 62);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    驼褐
                </h3>
                <div class="color__hex">#7C5B3E</div>
                <div class="color__rgb">RGB(124, 91, 62)</div>
                <div class="color__cmyk">CMYK(55,65,80,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#72453A"
                data-cmyk-text="CMYK(55,75,75,25)"
                style="background-color: rgb(114, 69, 58);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    椒褐
                </h3>
                <div class="color__hex">#72453A</div>
                <div class="color__rgb">RGB(114, 69, 58)</div>
                <div class="color__cmyk">CMYK(55,75,75,25)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Heavy-Snow">
        <h2>大雪</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#EFC4CE"
                data-cmyk-text="CMYK(5,30,10,0)"
                style="background-color: rgb(239, 196, 206);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    粉米
                </h3>
                <div class="color__hex">#EFC4CE</div>
                <div class="color__rgb">RGB(239, 196, 206)</div>
                <div class="color__cmyk">CMYK(5,30,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CE8892"
                data-cmyk-text="CMYK(20,55,30,0)"
                style="background-color: rgb(206, 136, 146);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    縓缘
                </h3>
                <div class="color__hex">#CE8892</div>
                <div class="color__rgb">RGB(206, 136, 146)</div>
                <div class="color__cmyk">CMYK(20,55,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C35C6A"
                data-cmyk-text="CMYK(25,75,45,0)"
                style="background-color: rgb(195, 92, 106);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    美人祭
                </h3>
                <div class="color__hex">#C35C6A</div>
                <div class="color__rgb">RGB(195, 92, 106)</div>
                <div class="color__cmyk">CMYK(25,75,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#B04552"
                data-cmyk-text="CMYK(35,85,60,0)"
                style="background-color: rgb(176, 69, 82);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鞓红
                </h3>
                <div class="color__hex">#B04552</div>
                <div class="color__rgb">RGB(176, 69, 82)</div>
                <div class="color__cmyk">CMYK(35,85,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EEEAD9"
                data-cmyk-text="CMYK(5,5,15,5)"
                style="background-color: rgb(238, 234, 217);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    米汤娇
                </h3>
                <div class="color__hex">#EEEAD9</div>
                <div class="color__rgb">RGB(238, 234, 217)</div>
                <div class="color__cmyk">CMYK(5,5,15,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BFC1A9"
                data-cmyk-text="CMYK(30,25,35,0)"
                style="background-color: rgb(191, 193, 169);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    草白
                </h3>
                <div class="color__hex">#BFC1A9</div>
                <div class="color__rgb">RGB(191, 193, 169)</div>
                <div class="color__cmyk">CMYK(30,25,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A9A082"
                data-cmyk-text="CMYK(40,35,50,0)"
                style="background-color: rgb(169, 160, 130);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    玄校
                </h3>
                <div class="color__hex">#A9A082</div>
                <div class="color__rgb">RGB(169, 160, 130)</div>
                <div class="color__cmyk">CMYK(40,35,50,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#756C4B"
                data-cmyk-text="CMYK(60,55,75,10)"
                style="background-color: rgb(117, 108, 75);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    綟绶
                </h3>
                <div class="color__hex">#756C4B</div>
                <div class="color__rgb">RGB(117, 108, 75)</div>
                <div class="color__cmyk">CMYK(60,55,75,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#788A6F"
                data-cmyk-text="CMYK(60,40,60,0)"
                style="background-color: rgb(120, 138, 111);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    雀梅
                </h3>
                <div class="color__hex">#788A6F</div>
                <div class="color__rgb">RGB(120, 138, 111)</div>
                <div class="color__cmyk">CMYK(60,40,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#5D7259"
                data-cmyk-text="CMYK(70,50,70,5)"
                style="background-color: rgb(93, 114, 89);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    油绿
                </h3>
                <div class="color__hex">#5D7259</div>
                <div class="color__rgb">RGB(93, 114, 89)</div>
                <div class="color__cmyk">CMYK(70,50,70,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4E6548"
                data-cmyk-text="CMYK(75,55,80,10)"
                style="background-color: rgb(78, 101, 72);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    莓莓
                </h3>
                <div class="color__hex">#4E6548</div>
                <div class="color__rgb">RGB(78, 101, 72)</div>
                <div class="color__cmyk">CMYK(75,55,80,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#3F503B"
                data-cmyk-text="CMYK(80,65,85,20)"
                style="background-color: rgb(63, 80, 59);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    螺青
                </h3>
                <div class="color__hex">#3F503B</div>
                <div class="color__rgb">RGB(63, 80, 59)</div>
                <div class="color__cmyk">CMYK(80,65,85,20)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A4ABD6"
                data-cmyk-text="CMYK(40,30,0,0)"
                style="background-color: rgb(164, 171, 214);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    暮山紫
                </h3>
                <div class="color__hex">#A4ABD6</div>
                <div class="color__rgb">RGB(164, 171, 214)</div>
                <div class="color__cmyk">CMYK(40,30,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#757CBB"
                data-cmyk-text="CMYK(60,50,0,0)"
                style="background-color: rgb(117, 124, 187);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫苑
                </h3>
                <div class="color__hex">#757CBB</div>
                <div class="color__rgb">RGB(117, 124, 187)</div>
                <div class="color__cmyk">CMYK(60,50,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#615EA8"
                data-cmyk-text="CMYK(70,65,0,0)"
                style="background-color: rgb(97, 94, 168);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    优昙瑞
                </h3>
                <div class="color__hex">#615EA8</div>
                <div class="color__rgb">RGB(97, 94, 168)</div>
                <div class="color__cmyk">CMYK(70,65,0,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#4A4B9D"
                data-cmyk-text="CMYK(80,75,0,0)"
                style="background-color: rgb(74, 75, 157);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    延维
                </h3>
                <div class="color__hex">#4A4B9D</div>
                <div class="color__rgb">RGB(74, 75, 157)</div>
                <div class="color__cmyk">CMYK(80,75,0,0)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Winter-Solstice">
        <h2>冬至</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#E7CAD3"
                data-cmyk-text="CMYK(10,25,10,0)"
                style="background-color: rgb(231, 202, 211);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    银红
                </h3>
                <div class="color__hex">#E7CAD3</div>
                <div class="color__rgb">RGB(231, 202, 211)</div>
                <div class="color__cmyk">CMYK(10,25,10,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D9A0B3"
                data-cmyk-text="CMYK(15,45,15,0)"
                style="background-color: rgb(217, 160, 179);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    莲红
                </h3>
                <div class="color__hex">#D9A0B3</div>
                <div class="color__rgb">RGB(217, 160, 179)</div>
                <div class="color__cmyk">CMYK(15,45,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BB7A8C"
                data-cmyk-text="CMYK(30,60,30,0)"
                style="background-color: rgb(187, 122, 140);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫梅
                </h3>
                <div class="color__hex">#BB7A8C</div>
                <div class="color__rgb">RGB(187, 122, 140)</div>
                <div class="color__cmyk">CMYK(30,60,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9E4E56"
                data-cmyk-text="CMYK(45,80,60,0)"
                style="background-color: rgb(158, 78, 86);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫矿
                </h3>
                <div class="color__hex">#9E4E56</div>
                <div class="color__rgb">RGB(158, 78, 86)</div>
                <div class="color__cmyk">CMYK(45,80,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DAA9A9"
                data-cmyk-text="CMYK(15,40,25,0)"
                style="background-color: rgb(218, 169, 169);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    咸池
                </h3>
                <div class="color__hex">#DAA9A9</div>
                <div class="color__rgb">RGB(218, 169, 169)</div>
                <div class="color__cmyk">CMYK(15,40,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CD7372"
                data-cmyk-text="CMYK(20,65,45,0)"
                style="background-color: rgb(205, 115, 114);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    红䵂
                </h3>
                <div class="color__hex">#CD7372</div>
                <div class="color__rgb">RGB(205, 115, 114)</div>
                <div class="color__cmyk">CMYK(20,65,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A85858"
                data-cmyk-text="CMYK(40,75,60,0)"
                style="background-color: rgb(168, 88, 88);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蚩尤旗
                </h3>
                <div class="color__hex">#A85858</div>
                <div class="color__rgb">RGB(168, 88, 88)</div>
                <div class="color__cmyk">CMYK(40,75,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7C4449"
                data-cmyk-text="CMYK(55,80,65,15)"
                style="background-color: rgb(124, 68, 73);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    霁红
                </h3>
                <div class="color__hex">#7C4449</div>
                <div class="color__rgb">RGB(124, 68, 73)</div>
                <div class="color__cmyk">CMYK(55,80,65,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EBE1A9"
                data-cmyk-text="CMYK(10,10,40,0)"
                style="background-color: rgb(235, 225, 169);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    莺儿
                </h3>
                <div class="color__hex">#EBE1A9</div>
                <div class="color__rgb">RGB(235, 225, 169)</div>
                <div class="color__cmyk">CMYK(10,10,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E1D279"
                data-cmyk-text="CMYK(15,15,60,0)"
                style="background-color: rgb(225, 210, 121);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    禹余粮
                </h3>
                <div class="color__hex">#E1D279</div>
                <div class="color__rgb">RGB(225, 210, 121)</div>
                <div class="color__cmyk">CMYK(15,15,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#D6BC46"
                data-cmyk-text="CMYK(20,25,80,0)"
                style="background-color: rgb(214, 188, 70);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    姚黄
                </h3>
                <div class="color__hex">#D6BC46</div>
                <div class="color__rgb">RGB(214, 188, 70)</div>
                <div class="color__cmyk">CMYK(20,25,80,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BE8A2F"
                data-cmyk-text="CMYK(30,50,90,0)"
                style="background-color: rgb(190, 138, 47);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    蛾黄
                </h3>
                <div class="color__hex">#BE8A2F</div>
                <div class="color__rgb">RGB(190, 138, 47)</div>
                <div class="color__cmyk">CMYK(30,50,90,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#796860"
                data-cmyk-text="CMYK(60,60,60,5)"
                style="background-color: rgb(121, 104, 96);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    濯绛
                </h3>
                <div class="color__hex">#796860</div>
                <div class="color__rgb">RGB(121, 104, 96)</div>
                <div class="color__cmyk">CMYK(60,60,60,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#585248"
                data-cmyk-text="CMYK(70,65,70,20)"
                style="background-color: rgb(88, 82, 72);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    墨黪
                </h3>
                <div class="color__hex">#585248</div>
                <div class="color__rgb">RGB(88, 82, 72)</div>
                <div class="color__cmyk">CMYK(70,65,70,20)</div>
            </div>

            <div
                class="color"
                data-hex-text="#46433B"
                data-cmyk-text="CMYK(75,70,75,30)"
                style="background-color: rgb(70, 67, 59);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    驖骊
                </h3>
                <div class="color__hex">#46433B</div>
                <div class="color__rgb">RGB(70, 67, 59)</div>
                <div class="color__cmyk">CMYK(75,70,75,30)</div>
            </div>

            <div
                class="color"
                data-hex-text="#31322C"
                data-cmyk-text="CMYK(80,75,80,45)"
                style="background-color: rgb(49, 50, 44);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    京元
                </h3>
                <div class="color__hex">#31322C</div>
                <div class="color__rgb">RGB(49, 50, 44)</div>
                <div class="color__cmyk">CMYK(80,75,80,45)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Lesser-Cold">
        <h2>小寒</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#F6F9E4"
                data-cmyk-text="CMYK(5,0,15,0)"
                style="background-color: rgb(246, 249, 228);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    酂白
                </h3>
                <div class="color__hex">#F6F9E4</div>
                <div class="color__rgb">RGB(246, 249, 228)</div>
                <div class="color__cmyk">CMYK(5,0,15,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#ECEBC2"
                data-cmyk-text="CMYK(10,5,30,0)"
                style="background-color: rgb(236, 235, 194);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    断肠
                </h3>
                <div class="color__hex">#ECEBC2</div>
                <div class="color__rgb">RGB(236, 235, 194)</div>
                <div class="color__cmyk">CMYK(10,5,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#E1D384"
                data-cmyk-text="CMYK(15,15,55,0)"
                style="background-color: rgb(225, 211, 132);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    田赤
                </h3>
                <div class="color__hex">#E1D384</div>
                <div class="color__rgb">RGB(225, 211, 132)</div>
                <div class="color__cmyk">CMYK(15,15,55,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CAB272"
                data-cmyk-text="CMYK(25,30,60,0)"
                style="background-color: rgb(202, 178, 114);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    黄封
                </h3>
                <div class="color__hex">#CAB272</div>
                <div class="color__rgb">RGB(202, 178, 114)</div>
                <div class="color__cmyk">CMYK(25,30,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BD9683"
                data-cmyk-text="CMYK(30,45,45,0)"
                style="background-color: rgb(189, 150, 131);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    丁香褐
                </h3>
                <div class="color__hex">#BD9683</div>
                <div class="color__rgb">RGB(189, 150, 131)</div>
                <div class="color__cmyk">CMYK(30,45,45,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#955A42"
                data-cmyk-text="CMYK(45,70,75,10)"
                style="background-color: rgb(149, 90, 66);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    棠梨褐
                </h3>
                <div class="color__hex">#955A42</div>
                <div class="color__rgb">RGB(149, 90, 66)</div>
                <div class="color__cmyk">CMYK(45,70,75,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#81492C"
                data-cmyk-text="CMYK(50,75,90,20)"
                style="background-color: rgb(129, 73, 44);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    朱石栗
                </h3>
                <div class="color__hex">#81492C</div>
                <div class="color__rgb">RGB(129, 73, 44)</div>
                <div class="color__cmyk">CMYK(50,75,90,20)</div>
            </div>

            <div
                class="color"
                data-hex-text="#68361A"
                data-cmyk-text="CMYK(55,80,100,35)"
                style="background-color: rgb(104, 54, 26);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    枣褐
                </h3>
                <div class="color__hex">#68361A</div>
                <div class="color__rgb">RGB(104, 54, 26)</div>
                <div class="color__cmyk">CMYK(55,80,100,35)</div>
            </div>

            <div
                class="color"
                data-hex-text="#7D929F"
                data-cmyk-text="CMYK(55,35,30,5)"
                style="background-color: rgb(125, 146, 159);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    秋蓝
                </h3>
                <div class="color__hex">#7D929F</div>
                <div class="color__rgb">RGB(125, 146, 159)</div>
                <div class="color__cmyk">CMYK(55,35,30,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#576470"
                data-cmyk-text="CMYK(70,55,45,15)"
                style="background-color: rgb(87, 100, 112);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    育阳染
                </h3>
                <div class="color__hex">#576470</div>
                <div class="color__rgb">RGB(87, 100, 112)</div>
                <div class="color__cmyk">CMYK(70,55,45,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#3C4654"
                data-cmyk-text="CMYK(80,70,55,25)"
                style="background-color: rgb(60, 70, 84);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    霁蓝
                </h3>
                <div class="color__hex">#3C4654</div>
                <div class="color__rgb">RGB(60, 70, 84)</div>
                <div class="color__cmyk">CMYK(80,70,55,25)</div>
            </div>

            <div
                class="color"
                data-hex-text="#151D29"
                data-cmyk-text="CMYK(85,75,60,65)"
                style="background-color: rgb(21, 29, 41);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    獭见
                </h3>
                <div class="color__hex">#151D29</div>
                <div class="color__rgb">RGB(21, 29, 41)</div>
                <div class="color__cmyk">CMYK(85,75,60,65)</div>
            </div>

            <div
                class="color"
                data-hex-text="#A4C9CC"
                data-cmyk-text="CMYK(40,10,20,0)"
                style="background-color: rgb(164, 201, 204);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    井天
                </h3>
                <div class="color__hex">#A4C9CC</div>
                <div class="color__rgb">RGB(164, 201, 204)</div>
                <div class="color__cmyk">CMYK(40,10,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#6CA8AF"
                data-cmyk-text="CMYK(60,20,30,0)"
                style="background-color: rgb(108, 168, 175);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    正青
                </h3>
                <div class="color__hex">#6CA8AF</div>
                <div class="color__rgb">RGB(108, 168, 175)</div>
                <div class="color__cmyk">CMYK(60,20,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#509296"
                data-cmyk-text="CMYK(70,30,40,0)"
                style="background-color: rgb(80, 146, 150);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    扁青
                </h3>
                <div class="color__hex">#509296</div>
                <div class="color__rgb">RGB(80, 146, 150)</div>
                <div class="color__cmyk">CMYK(70,30,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#226B68"
                data-cmyk-text="CMYK(85,50,60,5)"
                style="background-color: rgb(34, 107, 104);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    䌦色
                </h3>
                <div class="color__hex">#226B68</div>
                <div class="color__rgb">RGB(34, 107, 104)</div>
                <div class="color__cmyk">CMYK(85,50,60,5)</div>
            </div>
        </div>
    </div>
    <div class="solar_term Greater-Cold">
        <h2>大寒</h2>
        <div class="colors">
            <div
                class="color"
                data-hex-text="#995D7F"
                data-cmyk-text="CMYK(45,70,30,5)"
                style="background-color: rgb(153, 93, 127);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫府
                </h3>
                <div class="color__hex">#995D7F</div>
                <div class="color__rgb">RGB(153, 93, 127)</div>
                <div class="color__cmyk">CMYK(45,70,30,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#814662"
                data-cmyk-text="CMYK(55,80,45,10)"
                style="background-color: rgb(129, 70, 98);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    地血
                </h3>
                <div class="color__hex">#814662</div>
                <div class="color__rgb">RGB(129, 70, 98)</div>
                <div class="color__cmyk">CMYK(55,80,45,10)</div>
            </div>

            <div
                class="color"
                data-hex-text="#602641"
                data-cmyk-text="CMYK(60,90,55,35)"
                style="background-color: rgb(96, 38, 65);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    芥拾紫
                </h3>
                <div class="color__hex">#602641</div>
                <div class="color__rgb">RGB(96, 38, 65)</div>
                <div class="color__cmyk">CMYK(60,90,55,35)</div>
            </div>

            <div
                class="color"
                data-hex-text="#420B2F"
                data-cmyk-text="CMYK(70,100,60,50)"
                style="background-color: rgb(66, 11, 47);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    油紫
                </h3>
                <div class="color__hex">#420B2F</div>
                <div class="color__rgb">RGB(66, 11, 47)</div>
                <div class="color__cmyk">CMYK(70,100,60,50)</div>
            </div>

            <div
                class="color"
                data-hex-text="#EBE3C7"
                data-cmyk-text="CMYK(10,10,25,0)"
                style="background-color: rgb(235, 227, 199);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    骨缥
                </h3>
                <div class="color__hex">#EBE3C7</div>
                <div class="color__rgb">RGB(235, 227, 199)</div>
                <div class="color__cmyk">CMYK(10,10,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#CAC5A0"
                data-cmyk-text="CMYK(25,20,40,0)"
                style="background-color: rgb(202, 197, 160);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    青白玉
                </h3>
                <div class="color__hex">#CAC5A0</div>
                <div class="color__rgb">RGB(202, 197, 160)</div>
                <div class="color__cmyk">CMYK(25,20,40,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#92896B"
                data-cmyk-text="CMYK(50,45,60,0)"
                style="background-color: rgb(146, 137, 107);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    绿豆褐
                </h3>
                <div class="color__hex">#92896B</div>
                <div class="color__rgb">RGB(146, 137, 107)</div>
                <div class="color__cmyk">CMYK(50,45,60,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#665F4D"
                data-cmyk-text="CMYK(65,60,70,15)"
                style="background-color: rgb(102, 95, 77);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    冥色
                </h3>
                <div class="color__hex">#665F4D</div>
                <div class="color__rgb">RGB(102, 95, 77)</div>
                <div class="color__cmyk">CMYK(65,60,70,15)</div>
            </div>

            <div
                class="color"
                data-hex-text="#DDC5B8"
                data-cmyk-text="CMYK(15,25,25,0)"
                style="background-color: rgb(221, 197, 184);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    肉红
                </h3>
                <div class="color__hex">#DDC5B8</div>
                <div class="color__rgb">RGB(221, 197, 184)</div>
                <div class="color__cmyk">CMYK(15,25,25,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#BEA89D"
                data-cmyk-text="CMYK(30,35,35,0)"
                style="background-color: rgb(190, 168, 157);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    珠子褐
                </h3>
                <div class="color__hex">#BEA89D</div>
                <div class="color__rgb">RGB(190, 168, 157)</div>
                <div class="color__cmyk">CMYK(30,35,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#8F6D5F"
                data-cmyk-text="CMYK(50,60,60,5)"
                style="background-color: rgb(143, 109, 95);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    鹰背褐
                </h3>
                <div class="color__hex">#8F6D5F</div>
                <div class="color__rgb">RGB(143, 109, 95)</div>
                <div class="color__cmyk">CMYK(50,60,60,5)</div>
            </div>

            <div
                class="color"
                data-hex-text="#694B3C"
                data-cmyk-text="CMYK(60,70,75,25)"
                style="background-color: rgb(105, 75, 60);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    麝香褐
                </h3>
                <div class="color__hex">#694B3C</div>
                <div class="color__rgb">RGB(105, 75, 60)</div>
                <div class="color__cmyk">CMYK(60,70,75,25)</div>
            </div>

            <div
                class="color"
                data-hex-text="#C8B6BB"
                data-cmyk-text="CMYK(25,30,20,0)"
                style="background-color: rgb(200, 182, 187);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    石英
                </h3>
                <div class="color__hex">#C8B6BB</div>
                <div class="color__rgb">RGB(200, 182, 187)</div>
                <div class="color__cmyk">CMYK(25,30,20,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9C8D9B"
                data-cmyk-text="CMYK(45,45,30,0)"
                style="background-color: rgb(156, 141, 155);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    银褐
                </h3>
                <div class="color__hex">#9C8D9B</div>
                <div class="color__rgb">RGB(156, 141, 155)</div>
                <div class="color__cmyk">CMYK(45,45,30,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#9D858F"
                data-cmyk-text="CMYK(45,50,35,0)"
                style="background-color: rgb(157, 133, 143);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    烟红
                </h3>
                <div class="color__hex">#9D858F</div>
                <div class="color__rgb">RGB(157, 133, 143)</div>
                <div class="color__cmyk">CMYK(45,50,35,0)</div>
            </div>

            <div
                class="color"
                data-hex-text="#76555D"
                data-cmyk-text="CMYK(60,70,55,10)"
                style="background-color: rgb(118, 85, 93);"
            >
                <h3
                    class="color__name"
                    style=`color:${state.map.get("right-text-hex")}`
                >
                    紫诰
                </h3>
                <div class="color__hex">#76555D</div>
                <div class="color__rgb">RGB(118, 85, 93)</div>
                <div class="color__cmyk">CMYK(60,70,55,10)</div>
            </div>
        </div>
    </div>
</div>
